var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrp5FrontFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 595.2 840.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".crp5_40{fill:#fff}.crp5_40,.crp5_42,.crp5_44{stroke:#000}.crp5_40,.crp5_42,.crp5_44{stroke-miterlimit:10}.crp5_40,.crp5_42{stroke-width:0.5px}.crp5_42,.crp5_44{fill:none}.crp5_44{stroke-width:0.75px}.crp5_45{fill:url(#19b1ef3d-b315-420e-ac05-1984dc6275fd)}.crp5_46{fill:url(#aa76518a-75ad-4b88-9886-da0d40bdffde)}.crp5_47{fill:url(#1cb5c83f-627b-483a-bf8e-7b63d564f2ec)}.crp5_48{fill:url(#6ea658f1-0fa6-4f95-86be-725fb11c7062)}.crp5_59{font-size:11.35px}.crp5_61,.crp5_71,.crp5_69,.crp5_68,.crp5_63,.crp5_65,.crp5_70,.crp5_67,.crp5_64,.crp5_59,.crp5_62{font-family:HelveticaNeue-Condensed, Helvetica Neue}.crp5_61{font-size:9.02px}.crp5_62{font-size:6.05px}.crp5_63{font-size:2px}.crp5_64{font-size:3px}.crp5_65{font-size:1px}.crp5_77{font-size:5px}.crp5_67{font-size:9px}.crp5_68{font-size:4px}.crp5_69{font-size:6px}.crp5_70{font-size:4.5px}.crp5_71{font-size:5.93px}.crp5_74{font-size:12.05px;fill:#a32136}.crp5_78,.crp5_74,.crp5_77{font-family:HelveticaNeue-Roman, Helvetica Neue}.crp5_76{letter-spacing:-0.02em}.crp5_77{letter-spacing:-0.02em}.crp5_78{font-size:14px;fill:#0033a1}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "19b1ef3d-b315-420e-ac05-1984dc6275fd",
    cx: 21.02,
    cy: 827.32,
    r: 1,
    gradientTransform: "matrix(7.15, 0, 0, -7.15, 147.35, 6333.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323232"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aa76518a-75ad-4b88-9886-da0d40bdffde",
    cx: -4.26,
    cy: 842.1,
    r: 1.63,
    xlinkHref: "#19b1ef3d-b315-420e-ac05-1984dc6275fd"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b77bdd68-3469-4159-9438-90470f127ecf",
    cx: 46.23,
    cy: 842.09,
    r: 1.63,
    xlinkHref: "#19b1ef3d-b315-420e-ac05-1984dc6275fd"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "1cb5c83f-627b-483a-bf8e-7b63d564f2ec",
    cx: -4.26,
    cy: 812.52,
    r: 1.63,
    xlinkHref: "#19b1ef3d-b315-420e-ac05-1984dc6275fd"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "6ea658f1-0fa6-4f95-86be-725fb11c7062",
    cx: 46.23,
    cy: 812.51,
    r: 1.63,
    xlinkHref: "#19b1ef3d-b315-420e-ac05-1984dc6275fd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "61d76ff7-76b5-48b8-9254-d8e91ca2c6f4",
    "data-name": "Main Part"
  }, /*#__PURE__*/React.createElement("path", {
    className: "crp5_40",
    d: "M297.13 197.63A223 223 0 0 0 97.46 321.25V520a223.06 223.06 0 0 0 400-1.34V322.59a223 223 0 0 0-200.33-124.96zM116.88 534.45a8 8 0 1 1 8.05-8 8 8 0 0 1-8.05 8zm0-211.55a8 8 0 1 1 8.05-8 8.06 8.06 0 0 1-8.05 8zm180.58 102.43a4.84 4.84 0 1 1 4.83-4.84 4.84 4.84 0 0 1-4.83 4.84zm180.45 109.12a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-211.55a8 8 0 1 1 8-8 8.06 8.06 0 0 1-8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crp5_42",
    d: "M231.79 422.49h7.17M297.46 480.99v5.63M248.71 466.49l5.32-4.8M233.85 438.8l6.94-1.78M239.82 453.96l6.29-3.43M259.93 476.38l4.1-5.88M273.4 483.59l2.63-6.66M286.72 487.28l1.17-7.07M313.04 486.28l-1.7-6.96M284.26 365.67l-1.37-5.62M233.38 425.81l5.66-.29M233.63 429.05l5.64-.58M234.04 432.26l5.6-.86M234.59 435.35l5.56-1.14M242.64 455.85l4.84-2.95M237.24 444.64l5.32-1.95M236.29 441.87l5.4-1.71M238.41 447.6l5.21-2.22M239.85 450.74l5.08-2.49M244.34 458.48l4.69-3.18M247.92 463.27l4.37-3.6M246.02 460.85l4.54-3.39M258.37 473.37l3.45-4.49M254.06 469.76l3.84-4.17M256.22 471.65l3.64-4.34M251.95 467.73l4.02-3.99M263.44 476.9l3-4.81M265.97 478.4l2.78-4.94M268.48 479.74l2.56-5.05M271.18 481.03l2.32-5.17M276.63 483.18l1.84-5.36M278.96 483.93l1.63-5.42M281.73 484.7l1.39-5.49M284.25 485.28l1.16-5.54M289.41 486.15l.71-5.62M292.33 486.45l.45-5.64M295.12 486.62l.21-5.67M300.21 488.09l-.4-7.14M302.46 486.46l-.44-5.64M305 486.21l-.67-5.62M307.97 485.79l-.93-5.59M315.17 484.17l-1.57-5.45M309.18 479.81l1.13 5.55M233.41 418.59l5.66.34M233.8 414.46l5.62.71M234.49 410.14l5.56 1.09M235.33 406.46l5.49 1.42M237.93 398.54l5.26 2.12M239.53 394.91l5.11 2.43M241.58 390.95l4.94 2.78M243.68 387.49l4.75 3.09M248.78 380.69l4.3 3.69M251.94 377.27l4.02 3.99M255.3 374.12l3.72 4.27M258.74 371.33l3.42 4.52M267.09 365.97l2.68 4.99M272.24 363.49l2.23 5.21M277.59 361.48l1.75 5.39M234.99 402.25l6.82 2.21M244.79 383.28l5.75 4.28M261.89 367.3l3.88 6.02M289.27 364.57l-1.01-7.1M317.09 367.39l2.41-6.75M347.27 391.81l6.1-3.76M348.16 451.68l6.21 3.58M293.87 358.65l.2 5.66M300.06 358.65l-.09 5.66M306.62 358.94l-.63 5.63M312.89 360.09l-1.2 5.54M326.35 364.87l-2.62 5.03M334.01 368.76l-3.56 4.41M340.85 373.98l-3.96 4.06M347.06 380.78l-4.35 3.62M357.57 398.02l-5.33 1.93M360.37 409.84l-5.6.85M361.24 422.85l-5.66-.09M358.31 438.66l-5.47-1.49M292.61 517.49l-.34 8.74M321.81 514.44l2.24 8.46M262.68 510.78l-3.14 8.17M234.84 495.35l-5.4 6.89M213.9 471.16l-7.38 4.71M202.3 442.43l-8.51 2.03M200.3 410.76l-8.69-1M347.91 503.23l4.59 7.44M369.32 485.45l6.46 5.91M383.54 464.39l7.73 4.09M201.4 375.96l7.89 3.8M221.41 346.61l6.08 6.29M249.13 326.36l4.03 7.76M400.41 442.64l-8.46-2.3M402.52 415.6l-8.74.44M398.26 388.75l-8.38 2.49M285.64 525.77l.65-6.46M278.65 524.84l1.07-6.41M272.64 523.07l1.5-6.33M265.88 521.23l1.92-6.21M298.99 526.41l-.13-6.5M304.96 526.11l-.5-6.48M311.29 525.43l-.88-6.44M317.66 524.36l-1.28-6.38M330.08 521.08l-2.03-6.17M335.81 519.01l-2.39-6.05M341.36 516.64l-2.72-5.91M346.96 513.85l-3.06-5.73M252.65 516.15l2.73-5.9M246.6 513.12l3.1-5.72M240.38 509.47l3.48-5.49M234.94 506.53l3.64-5.38M224.21 497.35l4.31-4.86M219.57 492.89l4.64-4.56M214.7 487.59l4.94-4.23M210.18 481.93l5.22-3.88M203.6 470.23l5.68-3.17M200.18 463.56l5.88-2.76M197.4 458.08l6.05-2.37M195.03 451.37l6.2-1.96M191.66 437.57l6.41-1.12M190.63 431.04l6.47-.65M357.71 506.67l-3.73-5.32M362.17 503.37l-4-5.12M366.61 499.71l-4.27-4.9M371.61 495.73l-4.52-4.67M379.56 487.14l-5.01-4.14M382.69 483.17l-5.2-3.9M385.83 477.87l-5.39-3.64M388.73 473.31l-5.56-3.35M393.02 463.29l-5.81-3M395.22 458.52l-5.93-2.71M397.29 453.42l-6.07-2.4M399.08 448.29l-6.18-2.08M403.08 420.84l-6.5-.03M402.93 426.05l-6.49-.35M402.31 431.66l-6.47-.67M401.48 436.85l-6.43-.98M196.64 423.47l-6.5.2M196.65 416.72l-6.5-.23M198.18 403.51l-6.4-1.16M199.64 396.78l-6.3-1.59M201.38 390.72l-6.19-1.99M203.59 384.53l-6.05-2.39M209.5 372.15l-10.92-6.16M213.16 366.52l-5.42-3.59M217.51 361.13l-5.15-3.97M221.41 356.25l-4.85-4.32M231.09 346.74l-4.22-4.95M235.85 342.5l-3.88-5.22M241.14 338.83l-3.53-5.46M246.58 335.16l-3.41-5.54M393.76 395.68l6.31-1.53M394.75 400.25l6.39-1.23M395.62 405.42l6.43-.9M396.16 411.1l6.47-.6M296.54 338.42v6.5M278.88 340.76l1.58 6.08M300.79 344.92l.01-4.91M305.36 338.7l-.45 6.48M308.9 345.66l.48-4.9M313.53 339.99l-1.14 6.4M316.32 347.28l.99-4.82M283.58 341.3l.94 4.62M288.26 339.17l.51 6.01M292.52 340.3l.25 4.88M260.9 341.67l4.87 10.57M265.27 346.84l1.82 4.33M269.4 343.61l2.19 6M274.47 343.61l1.37 4.44M260.15 347.74l2.87 5.62M256.34 351.49l2.4 4.12M251.15 352.67l3.5 5.63M321.5 342.26l-1.83 5.91M322.84 349.26l1.7-4.39M325.92 350.55l2.62-5.68M329.04 351.8l2.05-4.09M331.88 353.26l3.12-5.55M335 354.97l2.46-4.21M337.88 356.97l3.46-5.71M340.25 358.51l3.17-4.13M343 360.64l3.84-5.38M284.26 314.67l-.68-7.87M315.47 315.54l1.24-7.8M290.46 307.34l.33 6.83M296.56 307.32l-.03 6.84M303.14 307.34l-.22 6.84M309.68 307.75l-.6 6.81M345.47 325.25l3.36-7.16M323.35 310.39l-1.58 6.66M329.66 312.07l-1.94 6.56M335.97 313.93l-2.12 6.5M342.08 316.14l-2.47 6.38M373.19 345.56l5.62-5.56M355.32 322.87l-3.79 5.7M361.24 326.78l-4.08 5.49M366.88 330.94l-4.24 5.38M372.69 335.63l-4.52 5.13M394.22 375.5l7.15-3.36M383.41 346.42l-5.33 4.3M388.32 352.51l-5.68 3.81M392.77 358.9l-5.79 3.65M396.43 365.51l-5.97 3.33M403.39 411.02l7.9-.45M402.86 380.36l-6.49 2.17M405.35 387.51l-6.59 1.82M407.4 395.16l-6.76 1.05M408.75 402.99l-6.8.8M399.38 448.47l7.61 2.13M409.77 418.84l-6.84-.04M409.77 426.61l-6.84-.29M408.96 434.88l-6.76-1.02M407.79 442.64l-6.7-1.38M382.11 483.61l6.35 4.71M403.13 458.5l-6.3-2.67M399.98 466.11l-6.18-2.93M396.32 473.82l-5.96-3.36M392.17 481.17l-5.77-3.68M353.98 509.66l4.38 6.58M382.21 493.97l-5.16-4.49M376.87 500.03l-4.64-5.02M370.67 505.6l-4.47-5.18M364.43 510.82l-4.19-5.41M258.04 321.86l-2.79-7.4M261.16 313.33l2.17 6.48M266.58 311.45l1.82 6.59M272.12 309.93l1.63 6.64M277.83 308.71l1.27 6.72M237.17 332.69l-4.38-6.58M237.59 324.4l3.57 5.84M241.99 321.86l3.26 6.02M246.05 319.37l3.08 6.1M250.75 317.22l2.75 6.27M221.55 346.26l-5.67-5.5M219.72 338.28l4.73 4.95M223.03 335.11l4.46 5.19M226.38 332.45l4.31 5.32M229.85 329.62l4.01 5.54M210.28 359.38l-6.41-4.62M206.8 352.65l5.39 4.21M209.46 349.87l5.47 4.11M211.39 346.7l5.3 4.32M214.04 343.94l5.03 4.64M202.79 371.75l-7.04-3.61M200.32 363.25l5.74 3.73M201.48 360.66l5.74 3.72M203.22 358.14l5.67 3.82M197.71 383.18l-7.42-2.72M192.54 378.46l6.33 2.6M193.32 375.97l6.33 2.6M194.57 373.59l6.28 2.72M195.78 371.05l6.18 2.92M193.56 399.52l-7.74-1.64M191.68 410.14l-7.87-.77-1.02-1.49M182.38 418.76l1.25-3.95h7.98M181.79 425.17l1.42-3.42h8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crp5_42",
    d: "M183.21 433.34l.5-9.09h7.5M184.71 417.34h6.97M184.71 412.01l6.9.41M185.38 403.92l6.75 1.25M188.69 389.23l6.56 1.91M143.29 424.26h-11.83M463.29 424.26h-11.83M294.46 575.37v11.84M296.38 254.34v11.83M256.38 569.84l-3 11.45M338.44 259.76l-3 11.45M245.6 566.55l-4.35 11M357.43 265.98l-4.36 11M224.88 557.05l-5.64 10.41M375.42 274.38l-5.64 10.4M206.31 547.03l-5.83 8.41M390.85 283.86l-6.74 9.73M198.35 540.74l-7.77 8.93M405.23 295.04l-7.76 8.93M171.56 510.14l-9.65 6.84M427.81 318.99l-9.38 7.22M166.27 502.28l-10.02 6.3M436.83 331.93l-10.02 6.3M158.07 486.68l-10.56 5.35M444.4 345.32l-10.55 5.34M321.05 572.94l1.89 11.68M267.95 257.06l1.9 11.69M149.3 462.64l-11.33 3.42M455.2 372.26l-11.33 3.43M448.54 446.61l11.65 2.05M134.2 392.71l11.65 2.05M443.1 467.32l11.26 3.61M138.88 371.39l11.27 3.62M435.6 486.28l10.69 5.07M146.46 351.45l10.69 5.07M426.1 503.4l9.97 6.38M155.64 333.97l9.96 6.39M415.11 518.47l9.11 7.54M170.69 313.45l9.12 7.54M403.05 531.44l8.2 8.54M178.99 303.98l8.2 8.53M390.03 542.61l7.2 9.39M196.9 288.85l7.2 9.4M376.77 551.7l6.18 10.1M210.73 279.13l6.17 10.09M362.92 559.23l5.12 10.67M224.72 271.23l5.11 10.68M348.7 565.19l4.02 11.13M239.02 264.92l4.02 11.13M334.8 569.47l2.95 11.46M253.53 260.26l2.95 11.46M408.68 314.76l8.62-8.1M174.9 533.4l8.62-8.11M281.48 574.39l-1.56 11.73M318.29 255.79l-1.56 11.73M461.07 398.89l-11.74 1.49M215.22 551.27l-6.45 9.92M234.72 562.05l-4.78 10.82M268.78 572.99l-2.49 11.57M307.62 575.03l.7 11.81M151.66 470.82l-11.1 4.11M154.69 478.84l-11.05 4.23M147.29 454.87l-11.49 2.81M145.76 446.96l-11.68 1.9M144.61 439.27l-11.77 1.21M143.99 431.86l-11.81.68M143.63 416.55l-11.83-.14M144.04 409l-11.82-.56M144.71 401.96l-11.76-1.24M135.61 385.7l11.57 2.47M137.38 378.69l11.49 2.85M141.32 365.08l11.25 3.67M143.73 358.39l10.96 4.45M149.21 345.7l10.57 5.33M152.67 339.55l10.28 5.86M159.32 328.5l9.93 6.43M162.77 323.27l9.61 6.89M166.68 318.1l9.28 7.35M174.94 308.49l8.68 8.04M183.31 300.05l8.12 8.61M187.85 295.96l7.78 8.91M192.05 292.34l7.65 9.03M201.4 285.2l6.92 9.6M205.96 282.31l6.84 9.66M215.14 276.49l5.91 10.25M219.9 273.91l5.58 10.44M229.31 268.94l4.83 10.8M234.14 266.87l4.49 10.95M244.19 263.03l3.48 11.31M248.76 261.57l3.12 11.41M258.19 259.13l2.42 11.58M263.36 257.88l2.05 11.65M272.72 256.14l1.6 11.72M277.7 255.42l1.24 11.77M282.17 255.02l.75 11.81M287.19 254.68l.38 11.82M291.55 254.35l.38 11.82M293.79 256.14l.17 10.03M289.49 256.29l.17 10.04M284.65 256.65l.53 10.02M280.11 256.99l.79 10.01M275.51 257.59l1.15 9.97M270.73 258.31l1.39 9.94M265.96 259.19l1.75 9.88M261.2 260.25l1.96 9.84M256.32 261.25l2.29 9.77M251.67 262.62l2.64 9.69M246.87 264.13l2.88 9.61M242.14 265.68l3.23 9.5M237.28 267.4l3.47 9.43M232.18 269.57l4.21 9.12M227.96 271.73l4.21 9.11M222.99 273.91l4.7 8.87M218.23 276.8l5.02 8.7M213.7 279.35l5.24 8.56M209.31 282.06l5.54 8.37M204.77 285.2l5.75 8.23M200.16 288.51l6.04 8.02M195.51 291.52l6.2 7.89M190.95 295.24l6.65 7.52M186.61 299.25l6.91 7.28M182 303.04l7.08 7.11M177.95 307.65l7.33 6.85M173.86 312.23l7.6 6.56M169.96 316.97l7.9 6.19M166.02 321.77l8.05 6M162.44 326.71l8.25 5.71M159.12 332.26l8.46 5.41M155.46 337.67l8.59 5.18M152.43 343.27l8.78 4.87M149.42 349.37l9.05 4.35M146.67 355.84l9.2 4.01M144.03 362.35l9.37 3.58M141.78 368.75l9.55 3.07M139.79 375.47l9.67 2.72M138.12 382.47l9.73 2.48M136.31 389.78l9.87 1.81M135.34 396.98l9.92 1.56M134.43 404.79l10.01.76M133.58 412.42l10.03.29M133.58 420.45l10.04-.06M133.6 428.46l10.03-.42M134.12 436.11l10.02-.68M135.14 444.37l9.98-1.03M136.37 452.98l9.83-2.01M138.22 461.36l9.72-2.49M140.79 470.15l9.52-3.16M143.64 478.52l9.37-3.59M147.16 486.72l9.24-3.92M150.9 495.03l9-4.45M155.38 503.33l8.77-4.88M160.4 511.8l8.3-5.63M166.27 519.95l8.1-5.93M161.83 494.59l-10.34 5.75M177.41 518.08l-9.38 7.21M190.66 532.48l-8.37 8.37M172.36 528.27l7.69-6.45M179.58 535.92l7.32-6.87M187.76 544.89l6.83-7.36M196.06 552.01l6.27-7.84M205.24 558.53l5.57-8.35M214.69 563.14l5.26-8.55M225.17 568.89l4.46-8.99M236.15 573.6l3.88-9.26M248.12 577.92l2.85-9.63M260.12 581.32l2.25-9.78M273.37 583.74l1.44-9.93M287.44 585.27l.4-10.03M301.09 585.5l-.16-10.04M315.25 584.34l-.85-10M325.7 582.61l-1.48-9.93M328.63 582.25l-1.72-9.89M331.42 581.75l-1.83-9.87M334.8 581.21l-2.22-9.79M340.69 579.3l-2.51-9.72M343.57 578.63l-2.75-9.65M346.72 577.75l-2.87-9.62M349.59 576.63l-3.23-9.5M355.75 574.51l-3.68-9.34M358.98 573.34l-3.92-9.25M361.99 572.23l-4.03-9.19M365.11 570.77l-4.37-9.03M370.64 567.61l-4.55-8.94M373.74 566.13l-4.78-8.83M376.63 564.75l-4.88-8.78M379.6 563l-5.22-8.58M385.53 559.82l-5.31-8.87M388.52 558.03l-5.53-8.73M391.31 556.36l-5.63-8.66M394.15 554.3l-5.94-8.43M400.32 549.18l-6.7-7.87M402.97 546.93l-6.89-7.7M405.76 544.82l-6.98-7.62M408.57 542.42l-7.04-7.55M413.93 536.92l-7.44-7.17M416.67 534.42l-7.62-6.98M419.19 531.44l-7.7-6.89M421.52 528.47l-7.94-6.58M426.52 522.26l-8.19-6.3M428.96 519.47l-8.34-6.09M431.14 516.23l-8.41-5.99M433.13 513.02l-8.63-5.66M437.74 506.18l-8.86-5.32M439.91 502.42l-8.99-5.1M441.7 498.47l-9.04-4.99M443.8 494.57l-9.21-4.63M447.3 487.35l-9.38-4.32M449.12 483.29l-9.49-4.09M450.9 479.64l-9.53-3.98M452.14 475.09l-9.67-3.6M454.99 466.39l-9.96-2.78M456.41 462.21l-10.09-2.23M457.34 457.62l-10.11-2.1M458.31 453.02l-10.17-1.71M460.14 443.66l-10.24-1.39M460.67 439.26l-10.27-1.14M461.03 434.48l-10.29-.88M461.57 429.6l-10.31-.49M461.83 419.58l-10.33-.11M461.83 414.85l-10.33.15M461.42 409.75l-10.32.48M461 404.28l-10.27.88M459.48 393.93l-10.24 1.42M458.83 388.57l-10.19 1.66M457.65 382.83l-10.07 2.29M456.08 377.62l-9.96 2.67M452.62 367.17l-9.81 3.28M450.67 361.75l-9.72 3.51M448.63 356.27l-9.5 4.06M446.12 350.69l-9.32 4.42M442.12 343.29l-9.21 4.69M440.66 340.41l-9.1 4.91M439.13 337.85l-9.03 5.01M437.32 335l-8.82 5.35M434.2 330.11l-8.7 5.59M432.45 327.39l-8.56 5.8M430.67 325l-8.48 5.89M428.59 322.35l-8.24 6.21M424.77 316.85l-8.05 6.49M422.73 314.33l-7.88 6.69M420.71 312.15l-7.8 6.77M418.35 309.74l-7.52 7.05M414.4 305l-7.47 7.15M411.81 302.42l-7.29 7.32M409.25 300.21l-7.2 7.41M406.69 298.01l-6.9 7.67M401.33 293.17l-6.6 7.95M398.53 290.99l-6.41 8.1M395.97 288.73l-6.3 8.17M393.11 286.64l-5.98 8.4M387.13 282.39l-5.75 8.59M384.11 280.51l-5.53 8.73M381.29 278.53l-5.43 8.78M377.96 276.75l-5.08 8.97M371.33 273.69l-4.65 9.23M367.82 271.8l-4.42 9.34M364.31 270.32L360 279.7M360.71 268.94l-3.94 9.53M353.49 265.58l-3.65 9.68M349.84 264.44l-3.4 9.76M346.09 263.09l-2.96 9.89M342.11 262.1l-2.9 9.9M333.91 260.05l-2.04 10.13M330.03 259.08l-1.78 10.18M325.82 258.32l-1.67 10.2M321.84 257.58l-1.52 10.2M313.52 256.51l-.87 10.3M309.11 256.18l-.62 10.31M304.78 255.87l-.49 10.31M300.55 255.74l-.34 10.31M149.42 322.61l3 1.79s10.11-15.06 20.84-26.15a171.14 171.14 0 0 1 22.79-19.82c2.09-1.41 15.45-10.18 25-15a192.27 192.27 0 0 1 24.88-10.42l-.68-2.63M219.43 260.46l1.62 3.01M170.34 296.3l2.57 2.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.42 275.63l4.5 2.89-1.38-5.09-3.12 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crp5_44",
    d: "M124.93 375.3l3.71.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.97 377.35l2.57-.81-1.99-1.82-.58 2.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crp5_44",
    d: "M120.74 442.58l3.8-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.21 443.75l2.26-1.47-2.4-1.22.14 2.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crp5_44",
    d: "M281.86 598.66l.13-3.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.32 595.29l-1.26-2.37-1.43 2.28 2.69.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crp5_44",
    d: "M383 577.41l-1.65-3.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.73 573.75l-2.22-1.52-.2 2.69 2.42-1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crp5_44",
    d: "M361.01 587.32l-1.37-3.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.04 583.65l-2.1-1.68-.42 2.66 2.52-.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crp5_44",
    d: "M447.17 516.98l-3.16-2.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.09 513.96l-2.68-.19 1.18 2.42 1.5-2.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crp5_44",
    d: "M475.38 413.84h-3.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.96 412.49l-2.33 1.35 2.34 1.35-.01-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crp5_44",
    d: "M310.46 327.49l.31-4.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.03 318.26l2.1 6.19-2.38-1.59-2.56 1.28 2.84-5.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crp5_44",
    d: "M296.4 240.84l-.03 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.03 244.24l1.32 2.34 1.37-2.32-2.69-.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crp5_44",
    d: "M338.6 246.6l-.96 3.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.44 249.55l.7 2.6 1.9-1.91-2.6-.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crp5_42",
    d: "M391.07 381.09l4.77-2M392.66 385.08l4.89-1.67M461.07 349.92l-2.24 1.17a168.91 168.91 0 0 1 8.17 25.83 193.13 193.13 0 0 1 5.55 36.92c.53 10 1.5 20-3.33 43.15s-11.84 37.58-11.84 37.58l2.2.94M460.77 490.3l-1.33-.61M462.71 485.19l-1.34-.53M464.65 480.02l-1.5-.52M466.15 474.77l-1.39-.38M468.93 469.71l-2.6-.81M468.93 464.02l-1.27-.3M470.34 458.96l-1.53-.27M471.62 453.92l-1.78-.22M472.46 448.66l-1.64-.27M474.18 443.39l-2.51-.42M473.84 437.58l-1.49-.18M474.18 431.71l-1.38-.09M474.62 425.71h-1.66M474.43 419.71h-1.63M473.61 407.74l-1.5.12M472.96 401.46l-1.46.22M472.23 395.35l-1.56.23M471.5 389.11l-1.84.46M471.27 382.96l-2.82.55M468.68 376.46l-1.72.46M466.96 369.58l-1.72.63M465.15 363.17l-1.8.6M462.93 356.61l-1.73.66M138.9 556.23s27.31 36.19 77.19 56.82 87.72 16 98.73 15.75 41.84-6 68.18-17.88a212.7 212.7 0 0 0 74.92-57.58M298.41 625.49v6.81M302.09 627.09v2.25M305.8 627.09l.07 2.25M309.53 626.85l.11 2.24M313.06 626.65l.05 2.24M316.64 625.49l.3 5.94M320.25 626.11l.15 2.24M323.89 625.63l.19 2.24M327.59 625.21l.2 2.24M331.02 624.52l.27 2.23M337.86 623.22l.33 2.22M341.44 622.42l.38 2.22M344.9 621.69l.38 2.21M348.44 620.7l.46 2.19M355.21 618.85l.51 2.18M358.68 617.78l.63 2.16M362.33 616.57l.68 2.14M365.65 615.5l.72 2.13M372.32 613.09l.81 2.09M375.7 611.73l.9 2.06M379.24 610.23l.94 2.03M382.51 608.86l.89 2.06M389.03 605.59l1.01 2.01M392.27 603.92l1.09 1.96M395.65 602.08l1.13 1.94M398.77 600.41l1.09 1.97M404.69 596.83l1.17 1.92M407.78 594.9l1.25 1.87M411 592.8l1.29 1.83M413.98 590.88l1.24 1.87M419.45 586.81l1.35 1.79M422.33 584.57l1.43 1.74M425.31 582.15l1.48 1.7M428.08 579.94l1.43 1.74M433.41 575.57l1.48 1.69M436.12 573.13l1.55 1.63M438.93 570.51l1.59 1.59M441.54 568.11l1.54 1.63M446.45 562.81l1.62 1.55M448.93 560.15l1.69 1.48M451.5 557.28l1.72 1.44M453.88 554.66l1.68 1.49M295.05 627.09v2.25M291.34 627.09l-.07 2.25M287.61 626.85l-.11 2.24M284.07 626.65l-.04 2.24M280.5 625.49l-.3 5.94M276.92 626.18l-.14 2.24M273.28 625.7l-.18 2.23M269.58 625.28l-.19 2.24M266.12 624.87l-.27 2.22M258.95 623.68l-.34 2.22M255.37 622.89l-.38 2.21M251.9 622.15l-.38 2.21M248.37 621.16l-.47 2.2M241.62 619.58l-.51 2.18M238.15 618.51l-.63 2.16M234.5 617.31l-.69 2.13M231.17 616.23l-.72 2.13M224.83 614.13l-.78 2.1M221.43 612.82l-.87 2.07M217.88 611.36l-.92 2.05M214.59 610.04l-.87 2.07M208.25 607.14l-.98 2.01M205 605.5l-1.07 1.98M201.6 603.71l-1.12 1.95M198.45 602.08l-1.06 1.98M192.38 598.74l-1.16 1.91M189.29 596.8l-1.24 1.87M186.08 594.7l-1.29 1.84M183.1 592.78l-1.24 1.87M177.18 588.88l-1.32 1.81M174.27 586.69l-1.4 1.76M171.24 584.33l-1.44 1.72M168.43 582.17l-1.39 1.75M163.17 577.77l-1.48 1.69M160.46 575.34l-1.55 1.63M157.65 572.72l-1.59 1.59M155.04 570.32l-1.54 1.63M150.01 565.34l-1.61 1.55M147.53 562.68l-1.69 1.48M144.97 559.81l-1.72 1.44M142.59 557.19l-1.69 1.48M262.81 622.81l-1.04 6.74M245.54 618.97l-1.74 6.58M228.8 613.62l-2.27 6.43M196.5 598.67l-3.49 5.85M181.45 589.17l-4.07 5.66M166.88 578.83l-4.93 5.96M153.86 566.69l-4.82 4.81M142.17 553.56l-5.19 4.41M212.36 606.78l-2.91 6.16M334 622.08l1.4 8.46M351.34 618.4l1.75 6.41M385.11 605.88l2.72 5.91M368.24 612.47l2.56 6.69M400.86 597.18l3.46 5.87M416.2 588.1l3.93 5.56M429.45 576.09l4.58 5.59M443.08 564.6l4.63 4.45M455.01 550.79l5.18 4.42M447.03 565.48l2.07 1.95M449.81 562.62l2.09 1.93M452.41 559.61l2.1 1.92M456.51 554.83l2.17 1.83M451.21 561.17l2.11 1.9M453.86 558.09l2.17 1.85M448.5 564.06l2.63 2.4M455.36 556.4l3.56 2.98M433.63 578.07l2.37 2.73M436.69 575.51l1.88 2.13M439.58 572.78l1.89 2.12M444.14 568.43l1.98 2.04M438.22 574.2l1.91 2.11M441.18 571.42l3.09 3.22M435.23 576.81l1.94 2.16M442.84 569.88l1.93 1.98M419.54 589.57l1.69 2.28M422.78 587.24l1.71 2.27M425.81 584.78l2.85 3.49M430.74 580.76l1.82 2.18M424.41 586.06l1.74 2.25M427.56 583.5l1.81 2.2M421.23 588.43l1.69 2.21M429.34 582.1l1.8 2.16M404.33 599.5l1.5 2.42M407.75 597.45l1.52 2.4M411.03 595.21l1.54 2.38M416.21 591.63l1.64 2.33M409.47 596.4l2.48 3.81M412.82 594.11l1.62 2.34M406.11 598.51l1.55 2.4M414.7 592.86l1.64 2.3M388.28 608.29l1.29 2.53M391.87 606.54l2.14 4.14M395.33 604.59l1.33 2.52M400.81 601.48l1.89 3.25M393.67 605.64l1.34 2.51M397.21 603.66l1.41 2.46M390.14 607.45l1.32 2.5M399.2 602.57l1.43 2.46M371.64 615.44l1.01 2.65M375.39 614.08l1.03 2.65M379.04 612.52l1.05 2.64M384.83 610.01l1.15 2.6M377.28 613.39l1.07 2.63M381.02 611.79l1.13 2.6M373.58 614.8l1.76 4.44M383.11 610.92l1.45 3.26M354.25 621.22l1.35 4.8M358.11 620.2l.79 2.74M361.88 618.97l.81 2.72M367.86 616.98l.92 2.69M360.05 619.68l.83 2.72M363.91 618.41l1.18 3.51M356.24 620.76l.79 2.67M366.07 617.74l.92 2.67M336.61 625.54l.55 2.91M340.55 624.86l.54 2.79M344.52 623.96l.76 3.71M350.55 622.4l.68 2.76M342.53 624.51l.59 2.78M346.48 623.58l.67 2.77M338.63 625.25l.58 2.83M348.64 622.91l.73 2.9M318.69 628.49l.17 2.84M322.66 628.16l.21 2.83M326.54 627.6l.33 2.82M332.78 626.68l.44 2.81M324.61 627.98l.43 3.48M328.63 627.41l.43 2.81M320.73 628.38l.2 2.81M330.6 626.75l.5 3.17M282.33 628.95l-.16 2.84M286.31 629.24l-.14 2.84M290.28 629.3l-.12 2.84M296.58 629.37v2.84M288.32 629.38l-.11 2.84M292.38 629.44l-.03 2.84M284.36 629.16l-.15 3.65M294.64 629.5v4.64M264.1 626.82l-.5 3.54M268.04 627.44l-.38 2.82M272.06 628.02l-.24 2.83M278.27 628.42l-.24 2.83M270.03 627.74l-.34 2.82M274.07 628.14l-.43 4.68M266.1 627.19l-.36 2.93M276.32 628.39l-.29 3.55M246.39 623.16l-.69 2.76M250.25 624.19l-.67 2.77M254.14 624.99l-1.09 4.67M260.32 626.23l-.54 2.79M252.2 624.7l-.63 2.77M256.17 625.51l-.55 2.79M248.35 623.75l-.61 2.61M258.38 626l-.53 2.83M229.27 617.99l-.91 2.69M233.03 619.34l-.9 2.7M236.84 620.46l-.88 2.71M242.89 622.22l-.76 2.74M234.93 620.01l-1.37 4.32M238.82 621.16l-.78 2.73M231.17 618.74l-.88 2.72M240.99 621.82l-.75 2.69M212.29 611.19l-1.21 2.57M215.77 612.9l-1.65 4.15M219.64 614.34l-.98 2.75M225.45 616.73l-1.11 3.11M217.76 613.68l-1.09 2.63M221.54 615.16l-1.01 2.65M214.1 612.14l-1.1 2.43M223.64 616l-1 2.7M196.12 603.21l-1.41 2.46M199.55 605.24l-1.39 2.48M203.08 607.07l-1.37 2.48M208.69 609.94l-1.16 2.32M201.29 606.26l-1.36 2.5M204.9 608.12l-1.29 2.54M197.84 604.3l-2.19 3.97M206.89 609.19l-1.38 2.78M180.52 593.83l-2.54 3.7M183.87 595.86l-1.33 2.11M187.28 598.22L186 600.3M192.76 600.98l-1.39 2.48M185.57 596.95l-1.31 2.14M189.04 599.3l-1.6 2.56M182.25 594.77l-1.38 2.23M190.88 600.24l-1.25 2.25M166.01 582.89l-1.83 2.17M169.02 585.5l-1.63 1.98M172.17 587.92l-2.11 2.59M177.18 591.74l-1.47 1.97M170.55 586.81l-1.66 2.07M173.77 589.28l-1.49 1.97M167.51 584.27l-1.66 2.04M175.71 590.46l-1.62 2.18M152.43 571l-1.71 1.67M155.49 573.59l-1.82 1.8M158.39 576.31l-1.89 1.9M162.99 580.61l-1.66 1.81M156.89 575.04l-2.42 2.46M159.84 577.83l-1.68 1.81M154.11 572.21l-1.86 1.87M161.66 579.19l-1.83 2M140.1 557.54l-2.11 1.77M142.62 560.64l-2.46 2.1M145.3 563.57l-2.06 1.78M149.57 568.2l-2.48 2.32M143.9 562.19l-2 1.75M146.64 565.19l-1.81 1.68M141.34 559.16l-1.99 1.73M148.35 566.69l-1.97 1.85M300.52 629.31l-.04 2.84M304.51 629.43l-.03 3.39M308.48 629.32v2.75M314.76 628.8l.2 4.65M306.53 629.33l.02 2.66M310.56 628.9l.11 2.94M302.55 629.44l.01 2.63M312.83 629.06l.12 2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crp5_45",
    d: "M303.25 420.63h1a6.65 6.65 0 1 1-6.65-6.63 6.65 6.65 0 0 1 6.65 6.65h-2a4.65 4.65 0 1 0-4.65 4.65 4.66 4.66 0 0 0 4.65-4.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crp5_46",
    d: "M126.1 315h1.63a10.84 10.84 0 1 1-10.84-10.84A10.84 10.84 0 0 1 127.73 315h-3.26a7.58 7.58 0 1 0-7.58 7.58 7.59 7.59 0 0 0 7.58-7.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487 315h1.63a10.85 10.85 0 1 1-10.85-10.84A10.85 10.85 0 0 1 488.65 315h-3.27a7.58 7.58 0 1 0-7.58 7.59 7.59 7.59 0 0 0 7.58-7.59z",
    fill: "url(#b77bdd68-3469-4159-9438-90470f127ecf)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crp5_47",
    d: "M126.1 526.37h1.63a10.84 10.84 0 1 1-10.84-10.84 10.84 10.84 0 0 1 10.84 10.84h-3.26a7.58 7.58 0 1 0-7.58 7.58 7.58 7.58 0 0 0 7.58-7.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crp5_48",
    d: "M487 526.44h1.63a10.85 10.85 0 1 1-10.83-10.84 10.84 10.84 0 0 1 10.85 10.84h-3.27a7.58 7.58 0 1 0-7.58 7.56 7.58 7.58 0 0 0 7.58-7.58z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "66b5171e-c32e-4a48-aecf-78760456cdb9",
    "data-name": "Main Part Font"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.54 255.53c-91.11-54.09-208.81-24.08-262.89 67s-24.08 208.79 67 262.88 208.8 24.09 262.89-67 24.1-208.8-67-262.88zm-97.93 325.53c-88.85 0-160.88-71.95-160.88-160.7s72-160.71 160.88-160.71 160.88 72 160.88 160.71-72.03 160.7-160.88 160.7z",
    opacity: 0.07,
    stroke: "#231f20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.54 255.53c-91.11-54.09-208.81-24.08-262.89 67s-24.08 208.79 67 262.88 208.8 24.09 262.89-67 24.1-208.8-67-262.88zm-97.93 325.53c-88.85 0-160.88-71.95-160.88-160.7s72-160.71 160.88-160.71 160.88 72 160.88 160.71-72.03 160.7-160.88 160.7z",
    stroke: "#231f20",
    fill: "none",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(1, -0.03, 0.03, 1, 290.58, 254.12)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(1, 0.01, -0.01, 1, 295.96, 253.98)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(1, 0.03, -0.03, 1, 301.37, 254.03)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(326.12 256.43) rotate(10.29)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(0.98, 0.19, -0.19, 0.98, 328.78, 256.91)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(331.41 257.44) rotate(12.15)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.97, 0.23, -0.23, 0.97, 334.04, 257.99)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.97, 0.26, -0.26, 0.97, 338.21, 258.98)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.96, 0.27, -0.27, 0.96, 342.35, 260.09)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(360.33 266.24) rotate(22.53)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(362.32 267.06) rotate(23.28)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(364.27 267.9) rotate(24.01)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(366.23 268.77) rotate(24.75)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(368.18 269.67) rotate(25.49)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(370.09 270.58) rotate(26.22)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.89, 0.46, -0.46, 0.89, 372.01, 271.52)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(375.82 273.48) rotate(28.81)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(379.57 275.56) rotate(29.91)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.82, 0.57, -0.57, 0.82, 391.68, 283.12)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(393.43 284.34) rotate(35.54)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.81, 0.59, -0.59, 0.81, 395.16, 285.58)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.8, 0.6, -0.6, 0.8, 396.9, 286.86)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(398.6 288.14) rotate(37.74)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.78, 0.62, -0.62, 0.78, 400.28, 289.44)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.77, 0.64, -0.64, 0.77, 401.96, 290.76)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.75, 0.66, -0.66, 0.75, 405.27, 293.49)"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(408.51 296.32) rotate(42.13)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.68, 0.73, -0.73, 0.68, 418.72, 306.25)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(420.17 307.81) rotate(47.73)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.66, 0.75, -0.75, 0.66, 421.62, 309.4)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(423.03 311) rotate(49.19)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.64, 0.77, -0.77, 0.64, 424.44, 312.63)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.63, 0.78, -0.78, 0.63, 425.81, 314.24)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(428.51 317.57) rotate(52.49)"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(431.12 320.99) rotate(53.59)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.51, 0.86, -0.86, 0.51, 440.27, 334.58)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.5, 0.87, -0.87, 0.5, 441.37, 336.41)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.49, 0.87, -0.87, 0.49, 442.44, 338.27)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(443.49 340.12) rotate(61.8)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(445.51 343.88) rotate(63.27)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.43, 0.9, -0.9, 0.43, 447.44, 347.73)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(455.33 366.83) rotate(71.91)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(456.66 370.89) rotate(73.39)"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(457.87 375.01) rotate(74.5)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.25, 0.97, -0.97, 0.25, 458.44, 377.06)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(458.99 379.12) rotate(75.98)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(459.51 381.19) rotate(76.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(460 383.29) rotate(77.46)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(460.46 385.38) rotate(78.2)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(460.9 387.46) rotate(78.94)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.18, 0.98, -0.98, 0.18, 461.31, 389.57)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.17, 0.99, -0.99, 0.17, 461.69, 391.66)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(462.06 393.76) rotate(81.51)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.12, 0.99, -0.99, 0.12, 462.7, 398.02)"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.1, 0.99, -0.99, 0.1, 463.21, 402.27)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.09, 1, -1, 0.09, 463.43, 404.38)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.08, 1, -1, 0.08, 463.62, 406.53)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(463.79 408.65) rotate(86.27)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(463.93 410.79) rotate(87)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(464.04 412.92) rotate(87.72)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(464.12 415.07) rotate(88.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2.12,
    y: 0.02
  })), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(464.22 419.34) rotate(90.25)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(464.21 423.63) rotate(91.7)"
  }, "8"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(464.07 427.91) rotate(92.79)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(463.42 437.15) rotate(95.96)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(463.2 439.28) rotate(96.69)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(462.95 441.39) rotate(97.42)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(462.68 443.53) rotate(98.54)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.17, 0.98, -0.98, -0.17, 462.05, 447.75)"
  }, "9"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.19, 0.98, -0.98, -0.19, 461.29, 451.99)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.21, 0.98, -0.98, -0.21, 460.88, 454.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(460.44 456.17) rotate(102.6)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(459.98 458.25) rotate(103.34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(459.43 460.54) rotate(104.15)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.26, 0.97, -0.97, -0.26, 458.85, 462.85)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(458.26 465.12) rotate(106.35)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(-0.31, 0.95, -0.95, -0.31, 456.75, 470.27)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(455.04 475.41) rotate(109.62)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(454.15 477.93) rotate(110.55)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(-0.37, 0.93, -0.93, -0.37, 453.2, 480.46)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(-0.38, 0.92, -0.92, -0.38, 452.21, 482.97)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(451.18 485.46) rotate(113.34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(450.13 487.92) rotate(114.55)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(448.36 491.8) rotate(116.02)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(446.46 495.66) rotate(117.13)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(445.49 497.57) rotate(117.87)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.48, 0.88, -0.88, -0.48, 444.49, 499.46)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(443.46 501.34) rotate(119.34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(442.41 503.21) rotate(120.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.51, 0.86, -0.86, -0.51, 441.34, 505.05)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(440.27 506.88) rotate(121.91)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.55, 0.84, -0.84, -0.55, 438.01, 510.5)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.57, 0.82, -0.82, -0.57, 435.63, 514.1)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.58, 0.82, -0.82, -0.58, 434.42, 515.86)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.59, 0.81, -0.81, -0.59, 433.2, 517.6)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(431.93 519.34) rotate(126.68)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(430.66 521.05) rotate(127.41)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(429.36 522.74) rotate(128.14)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.63, 0.77, -0.77, -0.63, 428.05, 524.43)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(425.34 527.75) rotate(130.7)"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(422.53 531) rotate(131.8)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(421.11 532.59) rotate(132.53)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.69, 0.73, -0.73, -0.69, 419.68, 534.16)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(418.2 535.73) rotate(133.99)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.7, 0.71, -0.71, -0.7, 416.72, 537.26)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.72, 0.7, -0.7, -0.72, 415.23, 538.78)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(412.16 541.77) rotate(137.28)"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(408.99 544.68) rotate(138.38)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.76, 0.65, -0.65, -0.76, 407.4, 546.09)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(405.79 547.48) rotate(139.83)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.77, 0.64, -0.64, -0.77, 404.14, 548.88)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(402.52 550.22) rotate(141.66)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.8, 0.6, -0.6, -0.8, 399.16, 552.89)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.81, 0.58, -0.58, -0.81, 395.7, 555.46)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(393.97 556.71) rotate(144.97)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(392.23 557.93) rotate(145.7)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(390.46 559.14) rotate(146.43)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.84, 0.54, -0.54, -0.84, 388.68, 560.32)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(386.88 561.49) rotate(148.28)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.86, 0.5, -0.5, -0.86, 383.24, 563.74)"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.87, 0.49, -0.49, -0.87, 379.54, 565.89)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.88, 0.48, -0.48, -0.88, 377.68, 566.93)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(375.8 567.95) rotate(152.32)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(373.9 568.94) rotate(153.06)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(372.02 569.91) rotate(154.16)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.91, 0.41, -0.41, -0.91, 368.15, 571.79)"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(364.24 573.55) rotate(156.76)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(362.28 574.39) rotate(157.49)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(360.31 575.2) rotate(158.23)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(358.3 576) rotate(158.98)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.94, 0.34, -0.34, -0.94, 356.34, 576.77)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(352.32 578.23) rotate(161.57)"
  }, "8"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(348.24 579.57) rotate(162.68)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(346.19 580.22) rotate(163.42)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(344.16 580.82) rotate(164.16)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.97, 0.25, -0.25, -0.97, 342.1, 581.42)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(337.96 582.5) rotate(166.75)"
  }, "9"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.98, 0.21, -0.21, -0.98, 333.8, 583.47)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(331.7 583.93) rotate(168.6)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(329.61 584.35) rotate(169.43)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(-0.99, 0.17, -0.17, -0.99, 328.84, 584.52)"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(323.54 585.44) rotate(172.02)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(318.18 586.17) rotate(173.41)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(-1, -0.03, 0.03, -1, 293.34, 587.39)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.97, -0.25, 0.25, -0.97, 258.06, 582.76)"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(253.92 581.7) rotate(-164.13)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.96, -0.29, 0.29, -0.96, 249.8, 580.52)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(224.55 570.68) rotate(-153.64)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(222.66 569.74) rotate(-152.92)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(220.75 568.77) rotate(-152.18)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.88, -0.48, 0.48, -0.88, 218.86, 567.77)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.87, -0.49, 0.49, -0.87, 216.98, 566.74)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(215.11 565.7) rotate(-149.97)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.86, -0.51, 0.51, -0.86, 213.26, 564.63)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.85, -0.52, 0.52, -0.85, 211.43, 563.54)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(209.58 562.4) rotate(-147.76)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(207.77 561.27) rotate(-147.02)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(205.99 560.11) rotate(-146.29)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(-0.82, -0.57, 0.57, -0.82, 204.21, 558.95)"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(-0.8, -0.6, 0.6, -0.8, 199.8, 555.86)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(195.49 552.61) rotate(-141.78)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(-0.78, -0.62, 0.62, -0.78, 194.43, 551.78)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(-0.63, -0.78, 0.78, -0.63, 168.95, 526.91)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(-0.62, -0.79, 0.79, -0.62, 167.25, 524.82)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(-0.61, -0.8, 0.8, -0.61, 165.58, 522.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.59, -0.81, 0.81, -0.59, 163.96, 520.58)"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(161.43 517.11) rotate(-124.63)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(159 513.58) rotate(-123.53)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(149.31 497.21) rotate(-116.97)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(148.34 495.32) rotate(-116.24)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(147.39 493.39) rotate(-115.5)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(146.47 491.45) rotate(-114.76)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(145.58 489.52) rotate(-114.02)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.4, -0.92, 0.92, -0.4, 144.7, 487.55)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.38, -0.92, 0.92, -0.38, 143.86, 485.59)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.37, -0.93, 0.93, -0.37, 143.04, 483.63)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(142.25 481.65) rotate(-111.06)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(141.47 479.67) rotate(-109.76)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(139.64 474.59) rotate(-107.89)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(138 469.47) rotate(-106.5)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(136.44 464.02) rotate(-104.54)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(135.77 461.42) rotate(-103.61)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(-0.22, -0.98, 0.98, -0.22, 135.14, 458.81)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(134.55 456.18) rotate(-101.75)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(134 453.56) rotate(-100.82)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(133.49 450.91) rotate(-99.89)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(133.03 448.27) rotate(-98.97)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(-0.14, -0.99, 0.99, -0.14, 132.61, 445.61)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(-0.12, -0.99, 0.99, -0.12, 132.23, 442.94)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(131.9 440.26) rotate(-96.19)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.09, -1, 1, -0.09, 131.6, 437.6)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.06, -1, 1, -0.06, 131.23, 433.33)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(130.97 429.04) rotate(-92.46)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(130.96 428.87) rotate(-92.4)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(130.87 426.73) rotate(-91.68)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(130.82 424.56) rotate(-91.63)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(130.77 422.46) rotate(-89.77)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(130.77 420.3) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.02, -1, 1, 0.02, 130.78, 418.16)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(130.83 416.02) rotate(-88.06)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.05, -1, 1, 0.05, 130.9, 413.89)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(131 411.76) rotate(-86.61)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(131.13 409.61) rotate(-85.87)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.08, -1, 1, 0.08, 131.28, 407.47)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(131.46 405.36) rotate(-84.42)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.11, -0.99, 0.99, 0.11, 131.67, 403.23)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.12, -0.99, 0.99, 0.12, 131.91, 401.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(132.15 398.98) rotate(-81.65)"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(0.18, -0.98, 0.98, 0.18, 132.93, 393.65)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(133.9 388.35) rotate(-78.4)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(134.44 385.72) rotate(-77.47)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(0.23, -0.97, 0.97, 0.23, 135.02, 383.09)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(135.65 380.47) rotate(-75.6)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(0.26, -0.96, 0.96, 0.26, 136.32, 377.85)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(0.28, -0.96, 0.96, 0.28, 137.04, 375.26)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(137.79 372.67) rotate(-72.8)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(0.31, -0.95, 0.95, 0.31, 138.58, 370.11)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(139.42 367.56) rotate(-70.94)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(0.34, -0.94, 0.94, 0.34, 140.3, 365)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.36, -0.93, 0.93, 0.36, 141.2, 362.49)"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(142.75 358.5) rotate(-67.32)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.4, -0.92, 0.92, 0.4, 144.41, 354.55)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(145.28 352.58) rotate(-65.48)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(146.16 350.66) rotate(-64.74)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.44, -0.9, 0.9, 0.44, 147.07, 348.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(148.01 346.78) rotate(-63.26)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(148.98 344.87) rotate(-62.53)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(149.97 342.97) rotate(-61.79)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(150.98 341.08) rotate(-61.05)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(152.01 339.21) rotate(-60.31)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(153.07 337.35) rotate(-59.58)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.52, -0.86, 0.86, 0.52, 154.15, 335.51)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(155.26 333.68) rotate(-58.11)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(156.37 331.88) rotate(-57.01)"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.57, -0.82, 0.82, 0.57, 158.71, 328.28)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(161.13 324.75) rotate(-54.45)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(162.39 323) rotate(-53.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.6, -0.8, 0.8, 0.6, 163.65, 321.28)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(164.93 319.58) rotate(-52.25)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(166.25 317.87) rotate(-51.51)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(167.58 316.21) rotate(-50.78)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(168.94 314.54) rotate(-50.05)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(170.31 312.91) rotate(-49.32)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(171.69 311.29) rotate(-48.59)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(173.12 309.68) rotate(-47.86)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.68, -0.73, 0.73, 0.68, 174.54, 308.1)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.69, -0.72, 0.72, 0.69, 175.99, 306.53)"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.71, -0.7, 0.7, 0.71, 178.96, 303.45)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(182.03 300.43) rotate(-43.47)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.73, -0.69, 0.69, 0.73, 182.12, 300.35)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(183.67 298.89) rotate(-42.7)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.74, -0.67, 0.67, 0.74, 185.25, 297.42)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.75, -0.66, 0.66, 0.75, 186.83, 296)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(188.43 294.6) rotate(-40.51)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(190.07 293.2) rotate(-39.77)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.78, -0.63, 0.63, 0.78, 191.71, 291.84)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.78, -0.62, 0.62, 0.78, 193.39, 290.48)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(195.06 289.16) rotate(-37.58)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(196.72 287.85) rotate(-36.29)"
  }, "8"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(201.07 284.66) rotate(-34.44)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(205.51 281.63) rotate(-33.06)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(210.28 278.59) rotate(-31.12)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(0.86, -0.5, 0.5, 0.86, 212.57, 277.2)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(0.87, -0.49, 0.49, 0.87, 215.21, 275.67)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(0.88, -0.47, 0.47, 0.88, 217.88, 274.18)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.89, -0.45, 0.45, 0.89, 220.57, 272.74)"
  }, "8"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.9, -0.43, 0.43, 0.9, 224.38, 270.82)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(228.26 269) rotate(-24.19)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(242.43 263.3) rotate(-18.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(244.41 262.6) rotate(-17.6)"
  }, "9"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(249.56 260.96) rotate(-15.73)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(254.75 259.52) rotate(-14.34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(0.97, -0.23, 0.23, 0.97, 257.35, 258.85)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "matrix(0.98, -0.22, 0.22, 0.98, 259.96, 258.23)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(262.6 257.65) rotate(-11.55)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_59",
    transform: "translate(265.24 257.11) rotate(-10.61)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(267.89 256.6) rotate(-9.41)"
  }, "9"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(272.09 255.9) rotate(-7.95)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(240.9 251.45) rotate(-17.29)"
  }, "90"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.89, -0.46, 0.46, 0.89, 215.11, 262.09)"
  }, "85"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(167.31 299.26) rotate(-45.49)"
  }, "75"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.57, -0.82, 0.82, 0.57, 146.95, 326.37)"
  }, "70"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.28, 0.96, -0.96, -0.28, 470.37, 465.3)"
  }, "90"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.1, 0.99, -0.99, -0.1, 474.63, 439.27)"
  }, "85"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(470.72 379) rotate(78.06)"
  }, "75"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(0.37, 0.93, -0.93, 0.37, 459.83, 345.53)"
  }, "70"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "translate(475.93 409.4) rotate(87.73)"
  }, "80"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_61",
    transform: "matrix(-0.35, 0.94, -0.94, -0.35, 461.38, 492.25)"
  }, "95"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(284.44 355.57) rotate(-10.69) scale(0.25 1)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.99, -0.16, 0.16, 0.99, 284.77, 355.49)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.99, -0.12, 0.12, 0.99, 287.57, 355.03)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(290.44 354.69) rotate(-5.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(291.85 354.57) rotate(-3.88)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(293.28 354.47) rotate(-2.68)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(1, -0.03, 0.03, 1, 294.71, 354.41)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(296.15 354.38) rotate(-0.93)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(297.57 354.36) rotate(0.93)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(299 354.38) rotate(2.11)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(1, 0.06, -0.06, 1, 300.43, 354.44)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(301.86 354.52) rotate(4.51)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(303.3 354.63) rotate(5.73)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(304.7 354.77) rotate(6.93)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.99, 0.14, -0.14, 0.99, 306.13, 354.94)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.99, 0.16, -0.16, 0.99, 307.54, 355.15)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(308.94 355.38) rotate(10.58)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(310.37 355.64) rotate(11.81)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(311.78 355.94) rotate(13.04)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(313.15 356.26) rotate(14.25)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(314.54 356.61) rotate(15.48)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.96, 0.29, -0.29, 0.96, 315.92, 356.99)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_63",
    transform: "translate(317.3 357.41) rotate(17.52)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(317.73 357.53) rotate(18.94)"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(320.43 358.46) rotate(21.39)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.92, 0.39, -0.39, 0.92, 323.11, 359.52)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.64, 0.77, -0.77, 0.64, 348.74, 378.3)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(349.64 379.39) rotate(51.62)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(350.54 380.53) rotate(52.85)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.59, 0.81, -0.81, 0.59, 351.41, 381.68)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.57, 0.82, -0.82, 0.57, 352.24, 382.82)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_64",
    transform: "matrix(0.56, 0.83, -0.83, 0.56, 353.05, 384)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(353.45 384.56) rotate(57.68)"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(354.99 386.99) rotate(60.12)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(356.4 389.48) rotate(61.94)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(363.66 410.33) rotate(80.91)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(360.34 445.5) rotate(111.21)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(359.82 446.84) rotate(112.44)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.4, 0.92, -0.92, -0.4, 359.28, 448.17)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(358.7 449.48) rotate(114.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(358.1 450.78) rotate(116.12)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(357.47 452.07) rotate(117.34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.49, 0.87, -0.87, -0.49, 356.83, 453.33)"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(355.44 455.82) rotate(121.59)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(353.92 458.27) rotate(123.42)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(339.66 474.18) rotate(141.56)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.8, 0.61, -0.61, -0.8, 338.55, 475.06)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(337.4 475.93) rotate(143.98)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(336.25 476.77) rotate(145.18)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(335.09 477.58) rotate(146.39)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(333.88 478.38) rotate(147.61)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.86, 0.52, -0.52, -0.86, 332.68, 479.14)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(331.46 479.88) rotate(150.04)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(330.2 480.61) rotate(151.27)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(328.95 481.29) rotate(152.49)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(327.68 481.95) rotate(153.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(326.4 482.59) rotate(154.93)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(325.12 483.18) rotate(156.13)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.92, 0.38, -0.38, -0.92, 323.81, 483.77)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(322.48 484.32) rotate(158.59)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(321.17 484.84) rotate(159.8)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.95, 0.32, -0.32, -0.95, 319.81, 485.33)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(318.46 485.8) rotate(162.26)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_65",
    transform: "translate(317.1 486.23) rotate(162.97)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(316.89 486.31) rotate(163.97)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(314.86 486.9) rotate(166.11)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(312.07 487.58) rotate(167.94)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(307.35 488.46) rotate(172.03)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.99, 0.12, -0.12, -0.99, 305.98, 488.65)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(304.63 488.81) rotate(174.36)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(303.28 488.95) rotate(175.6)",
    fontSize: 7,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(301.72 489.08) rotate(177.44)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(298.86 489.2) rotate(179.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-1, -0.02, 0.02, -1, 297.44, 489.22)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(296 489.21) rotate(-178.39)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(294.57 489.17) rotate(-177.19)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(293.14 489.1) rotate(-175.99)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(291.7 489) rotate(-174.77)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.99, -0.11, 0.11, -0.99, 290.29, 488.87)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(288.87 488.71) rotate(-172.46)",
    fontSize: 5,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.99, -0.16, 0.16, -0.99, 287.69, 488.56)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(284.87 488.09) rotate(-168.91)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(283.45 487.82) rotate(-167.67)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(282.07 487.51) rotate(-166.46)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(280.68 487.18) rotate(-165.24)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(279.29 486.81) rotate(-164.01)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(-0.95, -0.3, 0.3, -0.95, 277.91, 486.42)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(275.9 485.79) rotate(-160.35)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(273.2 484.83) rotate(-157.91)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(270.54 483.74) rotate(-156.06)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(269.23 483.16) rotate(-154.84)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.9, -0.44, 0.44, -0.9, 267.93, 482.55)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(266.65 481.92) rotate(-152.4)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(265.39 481.25) rotate(-151.19)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(264.14 480.57) rotate(-149.97)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.86, -0.52, 0.52, -0.86, 262.9, 479.86)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(261.69 479.14) rotate(-146.95)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(259.27 477.56) rotate(-144.5)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.8, -0.61, 0.61, -0.8, 256.95, 475.89)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.78, -0.62, 0.62, -0.78, 255.83, 475.03)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(254.7 474.14) rotate(-140.28)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.76, -0.66, 0.66, -0.76, 253.59, 473.21)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_68",
    transform: "translate(252.51 472.27) rotate(-138.05)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.73, -0.68, 0.68, -0.73, 251.8, 471.64)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.72, -0.7, 0.7, -0.72, 250.77, 470.68)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.7, -0.72, 0.72, -0.7, 249.74, 469.7)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(247.75 467.65) rotate(-131.63)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.64, -0.77, 0.77, -0.64, 245.85, 465.49)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(244.93 464.38) rotate(-128.59)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.61, -0.79, 0.79, -0.61, 244.04, 463.27)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(243.18 462.15) rotate(-126.19)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(242.33 460.98) rotate(-124.97)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(241.51 459.82) rotate(-123.76)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.54, -0.84, 0.84, -0.54, 240.71, 458.61)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(239.94 457.43) rotate(-120.72)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.47, -0.88, 0.88, -0.47, 238.48, 454.98)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(237.13 452.45) rotate(-116.47)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.43, -0.9, 0.9, -0.43, 236.49, 451.17)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(235.88 449.87) rotate(-114.02)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.39, -0.92, 0.92, -0.39, 235.3, 448.56)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(234.74 447.23) rotate(-111.56)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_68",
    transform: "translate(234.22 445.91) rotate(-110.55)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(233.88 445.03) rotate(-109.54)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(233.4 443.66) rotate(-108.3)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(232.95 442.34) rotate(-106.48)"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(232.14 439.59) rotate(-104.03)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(231.45 436.81) rotate(-102.19)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(231.15 435.39) rotate(-100.96)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(-0.17, -0.99, 0.99, -0.17, 230.88, 434)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(230.64 432.59) rotate(-98.53)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(230.42 431.18) rotate(-97.31)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(230.24 429.75) rotate(-96.09)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(230.09 428.34) rotate(-94.89)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(229.96 426.9) rotate(-93.67)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(229.86 425.5) rotate(-91.88)"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.02, -1, 1, 0.02, 229.76, 422.64)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.04, -1, 1, 0.04, 229.8, 419.77)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(229.86 418.34) rotate(-86.51)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(229.95 416.9) rotate(-85.29)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(230.06 415.48) rotate(-84.09)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(230.21 414.05) rotate(-82.87)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.15, -0.99, 0.99, 0.15, 230.39, 412.63)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.17, -0.99, 0.99, 0.17, 230.6, 411.22)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(230.83 409.82) rotate(-79.22)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(231.1 408.4) rotate(-77.99)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(231.4 407.01) rotate(-76.78)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(231.73 405.62) rotate(-75.55)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(232.07 404.25) rotate(-73.72)"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(232.87 401.49) rotate(-71.26)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(233.8 398.78) rotate(-69.43)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(234.3 397.45) rotate(-68.22)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(234.83 396.12) rotate(-66.99)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(235.39 394.8) rotate(-65.76)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(235.98 393.49) rotate(-64.54)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.45, -0.89, 0.89, 0.45, 236.6, 392.2)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.47, -0.88, 0.88, 0.47, 237.24, 390.92)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(237.91 389.66) rotate(-60.88)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.51, -0.86, 0.86, 0.51, 238.6, 388.41)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(239.69 386.58) rotate(-57.85)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.55, -0.84, 0.84, 0.55, 240.44, 385.37)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(241.22 384.17) rotate(-54.82)"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(242.87 381.83) rotate(-52.39)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.63, -0.77, 0.77, 0.63, 244.62, 379.58)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.65, -0.76, 0.76, 0.65, 245.53, 378.46)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.67, -0.75, 0.75, 0.67, 246.47, 377.37)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.68, -0.73, 0.73, 0.68, 247.42, 376.31)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.7, -0.72, 0.72, 0.7, 248.4, 375.26)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(249.39 374.25) rotate(-44.55)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.73, -0.69, 0.69, 0.73, 250.41, 373.24)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(251.44 372.26) rotate(-42.14)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.76, -0.66, 0.66, 0.76, 252.51, 371.3)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(253.6 370.35) rotate(-39.7)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(254.69 369.45) rotate(-38.5)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(255.8 368.56) rotate(-37.31)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.81, -0.59, 0.59, 0.81, 256.95, 367.69)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "matrix(0.83, -0.56, 0.56, 0.83, 258.1, 366.84)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_62",
    transform: "translate(260.45 365.24) rotate(-31.84)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.86, -0.5, 0.5, 0.86, 254.74, 349.18)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(256.54 348.12) rotate(-28.6)"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.89, -0.45, 0.45, 0.89, 259.05, 346.76)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.91, -0.42, 0.42, 0.91, 261.61, 345.48)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_70",
    transform: "translate(262.06 343.06) rotate(-24.11)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_70",
    transform: "translate(263.54 342.4) rotate(-22.82)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_70",
    transform: "translate(265.54 341.55) rotate(-21.34)"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_70",
    transform: "translate(267.58 340.76) rotate(-20.22)"
  }, ","), /*#__PURE__*/React.createElement("text", {
    className: "crp5_70",
    transform: "matrix(0.94, -0.33, 0.33, 0.94, 268.6, 340.38)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_70",
    transform: "translate(270.68 339.67) rotate(-17.99)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_70",
    transform: "translate(271.71 339.33) rotate(-17.25)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_70",
    transform: "translate(272.77 339) rotate(-16.5)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(274.34 340.62) rotate(-15.41)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(276.35 340.06) rotate(-13.69)"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.98, -0.2, 0.2, 0.98, 279.1, 339.39)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(281.9 338.82) rotate(-10.24)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.99, -0.16, 0.16, 0.99, 283.3, 338.56)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(284.72 338.33) rotate(-8.26)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(286.11 338.13) rotate(-7.29)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(287.54 337.95) rotate(-6.3)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(1, -0.09, 0.09, 1, 288.94, 337.79)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(290.35 337.66) rotate(-4.35)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(291.76 337.55) rotate(-3.15)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(293.87 337.43) rotate(-1.45)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(296.68 337.34) rotate(0.93)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(1, 0.03, -0.03, 1, 299.57, 337.39)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(300.96 337.43) rotate(2.88)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(1, 0.07, -0.07, 1, 302.39, 337.51)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(303.8 337.6) rotate(4.83)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(305.25 337.72) rotate(5.82)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(306.65 337.87) rotate(6.79)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.99, 0.14, -0.14, 0.99, 308.08, 338.04)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(309.46 338.23) rotate(8.75)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.99, 0.17, -0.17, 0.99, 310.88, 338.44)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(312.27 338.67) rotate(11.23)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.98, 0.22, -0.22, 0.98, 315.07, 339.24)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(316.45 339.55) rotate(13.69)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.97, 0.25, -0.25, 0.97, 317.85, 339.89)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(319.21 340.25) rotate(15.68)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.96, 0.29, -0.29, 0.96, 320.6, 340.63)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.95, 0.3, -0.3, 0.95, 321.94, 341.04)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(323.31 341.47) rotate(18.65)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.94, 0.35, -0.35, 0.94, 324.66, 341.91)"
  }, "+"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.92, 0.38, -0.38, 0.92, 327.99, 343.16)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(330.61 344.25) rotate(24.59)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(333.21 345.45) rotate(26.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(334.48 346.07) rotate(27.06)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.88, 0.47, -0.47, 0.88, 335.74, 346.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(337.01 347.39) rotate(29.03)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.86, 0.51, -0.51, 0.86, 338.24, 348.05)"
  }, "+"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(341.31 349.88) rotate(32.97)"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(343.69 351.43) rotate(34.92)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.64, 0.77, -0.77, 0.64, 136.41, 568.39)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(137.85 570.13) rotate(48.9)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.68, 0.74, -0.74, 0.68, 140, 572.6)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.7, 0.72, -0.72, 0.7, 142.94, 575.78)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(145.93 578.85) rotate(44.83)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(147.45 580.37) rotate(44.18)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(148.99 581.86) rotate(43.56)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.73, 0.68, -0.68, 0.73, 150.55, 583.34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(152.1 584.79) rotate(42.2)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(154.42 586.9) rotate(41.18)"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(157.64 589.72) rotate(40.02)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(160.96 592.49) rotate(39.15)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(162.61 593.84) rotate(38.58)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.79, 0.62, -0.62, 0.79, 164.3, 595.19)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(165.99 596.51) rotate(37.43)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(167.68 597.81) rotate(36.73)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.81, 0.58, -0.58, 0.81, 170.19, 599.69)"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(173.68 602.2) rotate(34.6)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(177.22 604.63) rotate(33.74)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(179 605.82) rotate(33.16)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(180.79 606.99) rotate(32.59)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(182.59 608.14) rotate(32.01)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(184.43 609.29) rotate(31.43)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(186.25 610.41) rotate(30.71)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.87, 0.5, -0.5, 0.87, 188.96, 612.02)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(192.68 614.14) rotate(28.51)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(196.44 616.18) rotate(27.62)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.89, 0.45, -0.45, 0.89, 198.34, 617.17)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(200.27 618.15) rotate(26.41)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(202.19 619.11) rotate(25.81)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.91, 0.42, -0.42, 0.91, 204.1, 620.04)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(206.94 621.37) rotate(24.01)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(210.86 623.12) rotate(22.77)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(214.9 624.81) rotate(21.56)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(216.91 625.61) rotate(21.33)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(218.91 626.39) rotate(20.82)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(220.91 627.15) rotate(20.3)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(222.92 627.89) rotate(19.79)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.94, 0.33, -0.33, 0.94, 224.93, 628.62)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(226.98 629.33) rotate(18.74)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(228.98 630.02) rotate(17.95)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.96, 0.29, -0.29, 0.96, 233.07, 631.34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.96, 0.29, -0.29, 0.96, 235.13, 631.97)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(237.2 632.59) rotate(16.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(239.25 633.18) rotate(15.53)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.97, 0.26, -0.26, 0.97, 241.32, 633.76)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.97, 0.25, -0.25, 0.97, 243.4, 634.31)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(245.46 634.84) rotate(13.88)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.97, 0.23, -0.23, 0.97, 247.56, 635.37)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.98, 0.21, -0.21, 0.98, 251.73, 636.34)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(255.94 637.22) rotate(11.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.98, 0.18, -0.18, 0.98, 258.04, 637.63)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.98, 0.17, -0.17, 0.98, 260.15, 638.02)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(262.26 638.39) rotate(9.38)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.99, 0.15, -0.15, 0.99, 264.37, 638.74)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(266.5 639.07) rotate(8.23)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(268.61 639.38) rotate(7.36)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(272.86 639.93) rotate(6.2)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(1, 0.09, -0.09, 1, 277.15, 640.39)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(279.27 640.59) rotate(4.74)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(281.41 640.77) rotate(4.15)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(283.56 640.92) rotate(3.57)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(285.7 641.06) rotate(2.98)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(1, 0.04, -0.04, 1, 287.85, 641.17)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(1, 0.03, -0.03, 1, 289.96, 641.27)"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(1, 0.01, -0.01, 1, 294.25, 641.38)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(298.57 641.4) rotate(-0.46)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(1, -0.02, 0.02, 1, 300.7, 641.38)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(302.84 641.35) rotate(-1.52)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(1, -0.03, 0.03, 1, 304.99, 641.29)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(307.16 641.21) rotate(-2.42)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(309.3 641.12) rotate(-2.73)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(311.44 641.02) rotate(-2.79)"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(1, -0.05, 0.05, 1, 315.82, 640.85)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(320.32 640.59) rotate(-5.53)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(322.55 640.37) rotate(-6.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(324.77 640.11) rotate(-7.66)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(326.95 639.82) rotate(-8.46)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(329.07 639.5) rotate(-9.14)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(331.16 639.17) rotate(-9.76)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(333.26 638.81) rotate(-10.61)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(337.49 638.02) rotate(-11.66)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.98, -0.21, 0.21, 0.98, 341.72, 637.14)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(343.81 636.68) rotate(-12.87)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(345.89 636.2) rotate(-13.33)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.97, -0.24, 0.24, 0.97, 347.99, 635.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(350.09 635.19) rotate(-14.26)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.97, -0.25, 0.25, 0.97, 352.16, 634.66)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(354.23 634.13) rotate(-15.42)"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(358.37 632.99) rotate(-16.36)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.96, -0.29, 0.29, 0.96, 362.5, 631.77)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.95, -0.3, 0.3, 0.95, 364.55, 631.14)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(366.59 630.49) rotate(-18.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(368.63 629.82) rotate(-18.6)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.94, -0.33, 0.33, 0.94, 370.68, 629.14)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.94, -0.34, 0.34, 0.94, 372.7, 628.43)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(374.73 627.72) rotate(-20.53)"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(378.74 626.22) rotate(-21.73)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(382.72 624.62) rotate(-22.69)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(384.7 623.79) rotate(-23.36)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(386.73 622.92) rotate(-24.19)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(388.74 622.01) rotate(-25.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(390.77 621.06) rotate(-25.94)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(392.73 620.11) rotate(-26.73)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.88, -0.47, 0.47, 0.88, 394.63, 619.16)"
  }, "8"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(398.4 617.17) rotate(-29.14)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.87, -0.5, 0.5, 0.87, 402.18, 615.06)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.86, -0.51, 0.51, 0.86, 404.02, 613.99)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(405.88 612.89) rotate(-31.25)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(407.69 611.79) rotate(-31.8)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(409.51 610.66) rotate(-32.34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.84, -0.54, 0.54, 0.84, 411.34, 609.5)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(413.15 608.34) rotate(-33.64)"
  }, "9"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(416.71 605.97) rotate(-34.61)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.82, -0.58, 0.58, 0.82, 420.25, 603.52)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.81, -0.58, 0.58, 0.81, 422.01, 602.27)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(423.75 601.02) rotate(-36.26)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(425.49 599.75) rotate(-36.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.79, -0.61, 0.61, 0.79, 427.19, 598.48)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(430.63 595.86) rotate(-38.28)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.78, -0.63, 0.63, 0.78, 433.99, 593.2)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.77, -0.64, 0.64, 0.77, 437.32, 590.48)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.76, -0.65, 0.65, 0.76, 438.98, 589.1)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(440.62 587.72) rotate(-40.7)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(442.24 586.32) rotate(-41.14)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(443.87 584.9) rotate(-41.59)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(445.47 583.48) rotate(-42.27)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.73, -0.68, 0.68, 0.73, 448.65, 580.6)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.72, -0.7, 0.7, 0.72, 451.78, 577.66)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.71, -0.71, 0.71, 0.71, 454.85, 574.67)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.7, -0.71, 0.71, 0.7, 456.38, 573.14)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.7, -0.72, 0.72, 0.7, 457.89, 571.61)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(459.39 570.08) rotate(-46.64)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(462.34 566.96) rotate(-47.73)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.66, -0.75, 0.75, 0.66, 465.23, 563.79)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(384.8 392.03) rotate(72.87)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(385.62 394.72) rotate(74.18)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(386.01 396.07) rotate(75.06)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(386.37 397.42) rotate(75.93)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(386.71 398.78) rotate(76.81)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(387.03 400.16) rotate(77.69)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.2, 0.98, -0.98, 0.2, 387.33, 401.53)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(387.61 402.9) rotate(79.43)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.17, 0.98, -0.99, 0.17, 387.86, 404.28)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(388.1 405.65) rotate(81.16)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.14, 0.99, -0.99, 0.14, 388.31, 407.03)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(388.51 408.43) rotate(82.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(388.68 409.8) rotate(83.76)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.09, 0.99, -1, 0.09, 388.84, 411.22)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(388.97 412.61) rotate(85.49)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(389.08 414) rotate(86.35)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.04, 0.99, -1, 0.04, 389.17, 415.39)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(389.28 418.2) rotate(88.92)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(389.3 419.62) rotate(89.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(389.32 421) rotate(90.93)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(389.3 422.41) rotate(91.47)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(389.26 423.81) rotate(92.32)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(389.21 425.21) rotate(93.18)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(389.13 426.61) rotate(94.04)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.08, 0.99, -1, -0.09, 389.03, 428)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(388.91 429.42) rotate(95.77)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(388.77 430.8) rotate(96.63)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(388.61 432.21) rotate(97.5)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(388.43 433.57) rotate(98.35)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(388.22 434.97) rotate(99.23)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(388.01 436.33) rotate(100.53)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(387.5 439.09) rotate(102.27)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(386.89 441.84) rotate(103.58)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(386.56 443.21) rotate(104.46)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(386.21 444.57) rotate(105.34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(385.84 445.91) rotate(106.2)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.29, 0.95, -0.96, -0.29, 385.45, 447.27)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.31, 0.95, -0.95, -0.31, 385.04, 448.59)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(384.61 449.93) rotate(108.83)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(384.15 451.27) rotate(109.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(383.67 452.59) rotate(110.59)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(383.19 453.9) rotate(111.46)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(382.68 455.19) rotate(112.32)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.39, 0.91, -0.92, -0.39, 382.15, 456.48)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.41, 0.91, -0.91, -0.41, 381.6, 457.77)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(381.03 459.06) rotate(115.39)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(379.83 461.6) rotate(117.14)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(378.54 464.08) rotate(118.44)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(377.87 465.32) rotate(119.32)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.5, 0.86, -0.86, -0.5, 377.18, 466.55)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(376.48 467.75) rotate(121.05)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(375.75 468.97) rotate(121.94)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.54, 0.84, -0.84, -0.54, 375.02, 470.15)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.55, 0.83, -0.83, -0.55, 374.25, 471.33)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(373.48 472.5) rotate(124.54)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(372.69 473.63) rotate(125.4)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(371.87 474.79) rotate(126.27)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(371.05 475.91) rotate(127.13)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.61, 0.78, -0.79, -0.62, 370.2, 477.04)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(369.33 478.15) rotate(128.89)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.64, 0.77, -0.77, -0.64, 368.46, 479.23)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.65, 0.75, -0.75, -0.66, 367.57, 480.31)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(365.74 482.42) rotate(132.77)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.69, 0.72, -0.72, -0.7, 363.82, 484.47)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.7, 0.7, -0.71, -0.71, 362.84, 485.49)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.71, 0.69, -0.7, -0.72, 361.85, 486.48)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(360.85 487.45) rotate(136.68)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.73, 0.67, -0.67, -0.74, 359.82, 488.42)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(358.79 489.36) rotate(138.42)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(357.75 490.29) rotate(139.29)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.76, 0.64, -0.64, -0.77, 356.67, 491.21)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.77, 0.63, -0.63, -0.78, 355.62, 492.1)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(354.52 492.99) rotate(141.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(353.4 493.86) rotate(142.78)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(352.3 494.7) rotate(143.64)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(351.16 495.54) rotate(144.52)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.82, 0.57, -0.57, -0.82, 350.04, 496.34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.83, 0.55, -0.56, -0.83, 348.87, 497.15)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.84, 0.53, -0.54, -0.84, 347.71, 497.93)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.86, 0.51, -0.51, -0.86, 345.34, 499.44)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.87, 0.49, -0.49, -0.87, 342.94, 500.85)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(341.7 501.55) rotate(151.53)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.88, 0.46, -0.46, -0.89, 340.48, 502.21)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.89, 0.45, -0.45, -0.89, 339.24, 502.86)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(337.98 503.49) rotate(154.16)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(336.71 504.1) rotate(155.04)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(335.45 504.69) rotate(155.92)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(334.17 505.26) rotate(156.8)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.92, 0.38, -0.38, -0.93, 332.89, 505.81)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(331.6 506.35) rotate(158.56)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(330.29 506.86) rotate(159.45)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(328.97 507.35) rotate(160.34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(327.65 507.83) rotate(161.22)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(326.32 508.28) rotate(162.11)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(325.01 508.7) rotate(162.98)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(323.66 509.12) rotate(164.32)"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.97, 0.24, -0.24, -0.97, 320.96, 509.88)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(318.23 510.55) rotate(167.41)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(316.88 510.85) rotate(168.29)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(315.51 511.14) rotate(169.17)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.98, 0.17, -0.17, -0.98, 314.12, 511.4)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(312.74 511.64) rotate(170.94)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.99, 0.14, -0.14, -0.99, 311.37, 511.86)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(309.97 512.06) rotate(172.7)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(308.57 512.24) rotate(173.58)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(307.2 512.4) rotate(174.45)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(305.79 512.53) rotate(175.33)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(304.4 512.65) rotate(176.2)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.99, 0.05, -0.05, -1, 303, 512.74)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(301.58 512.81) rotate(177.95)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-1, 0.02, -0.02, -1, 300.18, 512.86)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(298.77 512.89) rotate(179.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(297.4 512.91) rotate(-179.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.99, -0.03, 0.03, -1, 296, 512.9)"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(293.19 512.81) rotate(-176.44)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(290.39 512.62) rotate(-175.13)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(288.99 512.51) rotate(-174.25)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.99, -0.11, 0.12, -0.99, 287.6, 512.37)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.99, -0.13, 0.13, -0.99, 286.2, 512.2)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(284.81 512.02) rotate(-171.61)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(283.42 511.82) rotate(-170.73)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.98, -0.18, 0.18, -0.98, 282.03, 511.59)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.98, -0.19, 0.19, -0.98, 280.66, 511.34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.97, -0.21, 0.21, -0.98, 279.29, 511.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(277.93 510.79) rotate(-167.21)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.97, -0.24, 0.24, -0.97, 276.54, 510.48)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.96, -0.25, 0.25, -0.97, 275.19, 510.15)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(273.82 509.79) rotate(-164.54)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.96, -0.28, 0.28, -0.96, 272.49, 509.42)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(271.14 509.03) rotate(-162.78)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(269.81 508.62) rotate(-161.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(268.48 508.18) rotate(-161.02)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.93, -0.35, 0.35, -0.94, 267.16, 507.74)"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.92, -0.37, 0.38, -0.93, 264.53, 506.76)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(261.93 505.7) rotate(-156.6)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(260.63 505.14) rotate(-155.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(259.35 504.56) rotate(-154.82)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.89, -0.44, 0.44, -0.9, 258.08, 503.97)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(256.83 503.35) rotate(-153.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(255.59 502.72) rotate(-152.2)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(254.33 502.06) rotate(-151.31)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(253.12 501.39) rotate(-150.44)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(251.88 500.69) rotate(-149.55)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.85, -0.52, 0.52, -0.85, 250.68, 499.99)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(249.49 499.26) rotate(-147.81)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(248.3 498.52) rotate(-146.93)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(247.13 497.75) rotate(-146.06)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.82, -0.57, 0.57, -0.82, 245.96, 496.97)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.81, -0.58, 0.58, -0.81, 244.8, 496.16)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(243.68 495.35) rotate(-143.44)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(242.54 494.51) rotate(-142.56)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(241.44 493.67) rotate(-141.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(240.34 492.81) rotate(-140.4)"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(238.16 491.01) rotate(-138.65)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(236.06 489.15) rotate(-137.34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.72, -0.69, 0.69, -0.73, 235.04, 488.21)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.71, -0.7, 0.7, -0.71, 234.02, 487.24)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(233.02 486.26) rotate(-134.75)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(232.04 485.27) rotate(-133.88)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(231.06 484.25) rotate(-133.01)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(230.12 483.24) rotate(-132.15)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(229.17 482.19) rotate(-131.28)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(228.23 481.13) rotate(-130.4)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.63, -0.77, 0.77, -0.64, 227.34, 480.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.62, -0.78, 0.78, -0.62, 226.44, 478.99)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(225.57 477.91) rotate(-127.82)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(224.7 476.79) rotate(-126.94)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(223.86 475.67) rotate(-126.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(223.04 474.54) rotate(-125.21)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.56, -0.82, 0.83, -0.56, 222.23, 473.39)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(221.44 472.23) rotate(-123.47)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.53, -0.84, 0.85, -0.53, 220.65, 471.07)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(219.18 468.71) rotate(-120.43)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.48, -0.87, 0.87, -0.49, 217.75, 466.27)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(217.07 465.06) rotate(-118.25)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(216.41 463.83) rotate(-117.38)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(215.76 462.58) rotate(-116.5)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(215.13 461.31) rotate(-115.62)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(214.53 460.05) rotate(-114.75)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(213.94 458.78) rotate(-113.88)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(213.37 457.5) rotate(-113)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(212.83 456.21) rotate(-112.13)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(212.3 454.9) rotate(-111.25)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.35, -0.93, 0.94, -0.35, 211.79, 453.59)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.33, -0.94, 0.94, -0.33, 211.31, 452.3)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.32, -0.94, 0.95, -0.32, 210.84, 450.97)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(210.38 449.63) rotate(-107.75)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(209.96 448.32) rotate(-106.89)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(209.55 446.96) rotate(-106.01)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(209.17 445.63) rotate(-105.14)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(208.8 444.29) rotate(-103.83)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(208.12 441.54) rotate(-102.07)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(207.54 438.81) rotate(-100.77)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(207.28 437.43) rotate(-99.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(207.04 436.04) rotate(-99.03)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(206.82 434.65) rotate(-98.15)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(206.62 433.29) rotate(-97.3)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.11, -0.99, 0.99, -0.11, 206.44, 431.88)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.1, -0.99, 1, -0.1, 206.29, 430.5)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.08, -0.99, 1, -0.08, 206.15, 429.1)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.07, -0.99, 1, -0.07, 206.03, 427.69)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(205.94 426.3) rotate(-92.98)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(-0.04, -0.99, 1, -0.04, 205.87, 424.89)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(205.82 423.49) rotate(-91.26)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(205.79 422.08) rotate(-90.92)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.02, -1, 1, 0.02, 205.77, 420.7)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(205.78 419.29) rotate(-88.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(205.82 417.9) rotate(-87.87)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(205.87 416.49) rotate(-87.01)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(205.94 415.08) rotate(-86.14)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.09, -0.99, 1, 0.09, 206.03, 413.7)"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(206.28 410.9) rotate(-83.13)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(206.62 408.11) rotate(-81.82)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.16, -0.98, 0.99, 0.16, 206.82, 406.73)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(207.04 405.36) rotate(-80.1)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(207.28 403.97) rotate(-79.23)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(207.54 402.6) rotate(-78.35)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.22, -0.97, 0.98, 0.22, 207.82, 401.23)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(208.13 399.85) rotate(-76.6)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(208.46 398.48) rotate(-75.73)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(208.8 397.13) rotate(-74.86)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(209.17 395.76) rotate(-73.97)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(209.55 394.43) rotate(-73.11)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.3, -0.95, 0.95, 0.31, 209.96, 393.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(210.38 391.76) rotate(-71.36)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(210.83 390.43) rotate(-70.48)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(211.31 389.1) rotate(-69.6)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(211.8 387.78) rotate(-68.73)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_68",
    transform: "translate(212.3 386.48) rotate(-68)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_68",
    transform: "matrix(0.38, -0.92, 0.92, 0.38, 212.66, 385.61)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.4, -0.91, 0.92, 0.4, 213.01, 384.74)"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(214.14 382.16) rotate(-64.49)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(215.36 379.63) rotate(-63.18)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.46, -0.88, 0.89, 0.46, 215.98, 378.39)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(216.63 377.16) rotate(-61.45)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(217.31 375.9) rotate(-60.56)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(218 374.69) rotate(-59.7)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.52, -0.85, 0.86, 0.52, 218.7, 373.49)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(219.43 372.28) rotate(-57.95)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.54, -0.84, 0.84, 0.54, 220.17, 371.1)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(220.93 369.92) rotate(-56.22)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(221.71 368.76) rotate(-55.35)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(222.51 367.6) rotate(-54.48)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(223.32 366.46) rotate(-53.62)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(224.16 365.32) rotate(-52.74)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(225 364.22) rotate(-51.88)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.63, -0.77, 0.78, 0.63, 225.87, 363.11)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(226.74 362.03) rotate(-50.15)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(227.65 360.95) rotate(-49.28)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.66, -0.74, 0.75, 0.66, 228.56, 359.89)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(229.47 358.85) rotate(-47.12)"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.7, -0.71, 0.71, 0.7, 231.39, 356.78)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(233.37 354.78) rotate(-44.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(234.37 353.82) rotate(-43.21)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(235.4 352.86) rotate(-42.34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.75, -0.66, 0.66, 0.75, 236.44, 351.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(237.47 350.99) rotate(-40.61)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.77, -0.64, 0.64, 0.77, 238.55, 350.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.78, -0.62, 0.63, 0.78, 239.62, 349.18)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(240.71 348.3) rotate(-37.99)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(241.83 347.43) rotate(-37.11)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(242.93 346.59) rotate(-36.25)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.81, -0.58, 0.58, 0.82, 244.07, 345.76)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(245.21 344.95) rotate(-34.5)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.83, -0.55, 0.55, 0.83, 246.37, 344.15)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.84, -0.54, 0.54, 0.84, 247.53, 343.38)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(248.71 342.62) rotate(-31.88)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "matrix(0.85, -0.51, 0.52, 0.86, 249.9, 341.88)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.86, -0.49, 0.5, 0.87, 251.1, 341.15)",
    fontSize: 10,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(253.14 339.98) rotate(-28.21)"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_71",
    transform: "translate(255.62 338.65) rotate(-26.44)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(182.56 431.75) rotate(-94.83)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(182.32 428.91) rotate(-93.42)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(182.15 426.05) rotate(-92.02)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(182.05 423.19) rotate(-90.98)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(182 421.77) rotate(-89.07)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(182.03 418.91) rotate(-88.54)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(182.1 416.06) rotate(-87.14)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.07, -1, 1, 0.07, 182.25, 413.18)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(182.35 411.76) rotate(-85.38)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.1, -1, 1, 0.1, 182.45, 410.35)"
  }, "9"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.12, -0.99, 0.99, 0.12, 182.73, 407.52)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(183.09 404.68) rotate(-81.85)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(183.3 403.25) rotate(-81.13)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.17, -0.99, 0.99, 0.17, 183.52, 401.84)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(183.75 400.43) rotate(-79.36)"
  }, "8"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.21, -0.98, 0.98, 0.21, 184.27, 397.65)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.23, -0.97, 0.97, 0.23, 184.88, 394.84)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.24, -0.97, 0.97, 0.24, 185.2, 393.45)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.25, -0.97, 0.97, 0.25, 185.54, 392.06)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(185.9 390.68) rotate(-74.72)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(186.28 389.31) rotate(-74.01)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.29, -0.96, 0.96, 0.29, 186.67, 387.94)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(187.08 386.56) rotate(-72.58)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.31, -0.95, 0.95, 0.31, 187.51, 385.21)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.32, -0.95, 0.95, 0.32, 187.96, 383.84)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.34, -0.94, 0.94, 0.34, 188.4, 382.51)"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(189.38 379.82) rotate(-68.66)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(190.43 377.14) rotate(-67.58)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(190.97 375.84) rotate(-66.88)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.4, -0.91, 0.91, 0.4, 191.54, 374.51)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.42, -0.91, 0.91, 0.42, 192.1, 373.23)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(192.7 371.91) rotate(-64.73)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(193.31 370.63) rotate(-64.02)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(193.93 369.34) rotate(-62.95)"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.48, -0.88, 0.88, 0.48, 195.23, 366.8)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(196.59 364.29) rotate(-60.47)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(197.3 363.04) rotate(-59.75)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.51, -0.86, 0.86, 0.51, 198.02, 361.82)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(198.75 360.58) rotate(-58.34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.54, -0.84, 0.84, 0.54, 199.5, 359.38)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.55, -0.84, 0.84, 0.55, 200.26, 358.17)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.56, -0.83, 0.83, 0.56, 201.04, 356.97)"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(202.63 354.62) rotate(-54.45)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(204.3 352.29) rotate(-53.39)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.61, -0.8, 0.8, 0.61, 205.16, 351.14)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(206.02 350) rotate(-51.98)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.63, -0.78, 0.78, 0.63, 206.9, 348.87)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(207.8 347.76) rotate(-50.56)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(208.69 346.67) rotate(-49.87)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(209.61 345.58) rotate(-49.16)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(210.49 344.57) rotate(-48.5)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(211.38 343.56) rotate(-47.84)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(212.28 342.56) rotate(-47.18)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(213.17 341.6) rotate(-46.17)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(215.14 339.54) rotate(-44.77)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.72, -0.69, 0.69, 0.72, 217.18, 337.52)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.73, -0.68, 0.68, 0.73, 218.21, 336.54)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(219.26 335.56) rotate(-42.3)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(220.31 334.6) rotate(-41.59)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.76, -0.65, 0.65, 0.76, 221.38, 333.65)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(222.46 332.72) rotate(-40.18)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.77, -0.64, 0.64, 0.77, 223.55, 331.8)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(224.81 330.77) rotate(-38.68)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(226.06 329.76) rotate(-37.88)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(227.36 328.75) rotate(-37.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(228.64 327.79) rotate(-36.28)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.82, -0.58, 0.58, 0.82, 229.95, 326.82)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.83, -0.55, 0.55, 0.83, 232.29, 325.18)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.84, -0.54, 0.54, 0.84, 234.66, 323.6)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(235.87 322.83) rotate(-31.93)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.86, -0.52, 0.52, 0.86, 237.09, 322.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.86, -0.51, 0.51, 0.86, 238.32, 321.32)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.87, -0.5, 0.5, 0.87, 239.54, 320.6)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(240.77 319.9) rotate(-29.1)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(242.02 319.2) rotate(-28.38)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(243.29 318.52) rotate(-27.67)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(244.53 317.87) rotate(-26.97)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(245.81 317.21) rotate(-26.25)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.9, -0.43, 0.43, 0.9, 247.09, 316.58)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(248.37 315.97) rotate(-24.83)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(249.69 315.36) rotate(-24.11)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(250.97 314.79) rotate(-23.41)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.92, -0.38, 0.38, 0.92, 252.28, 314.21)"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(254.93 313.13) rotate(-20.9)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(257.6 312.11) rotate(-19.83)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(258.95 311.62) rotate(-19.12)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(260.29 311.16) rotate(-18.41)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.95, -0.3, 0.3, 0.95, 261.63, 310.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(263 310.27) rotate(-16.98)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.96, -0.28, 0.28, 0.96, 264.39, 309.85)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(265.75 309.45) rotate(-15.54)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.97, -0.26, 0.26, 0.97, 267.13, 309.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(268.51 308.71) rotate(-14.12)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(269.89 308.36) rotate(-13.4)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(271.26 308.03) rotate(-12.7)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.98, -0.21, 0.21, 0.98, 272.66, 307.72)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(274.05 307.42) rotate(-11.27)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(275.46 307.14) rotate(-10.55)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(276.86 306.88) rotate(-9.85)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(278.26 306.64) rotate(-9.14)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(279.69 306.41) rotate(-8.42)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(281.09 306.19) rotate(-7.36)"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(283.91 305.83) rotate(-5.95)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(286.75 305.54) rotate(-4.89)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(288.19 305.42) rotate(-4.18)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(289.61 305.31) rotate(-3.48)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(1, -0.05, 0.05, 1, 291.04, 305.22)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(1, -0.04, 0.04, 1, 292.45, 305.16)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(293.88 305.1) rotate(-1.38)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(295.32 305.07) rotate(-0.93)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(296.75 305.04) rotate(0.93)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1.42,
    y: -0.01
  })), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(1, 0.02, -0.02, 1, 299.61, 305.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(301.02 305.1) rotate(2.1)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(302.46 305.16) rotate(2.8)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(1, 0.06, -0.06, 1, 303.88, 305.23)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(1, 0.07, -0.07, 1, 305.31, 305.31)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(1, 0.09, -0.09, 1, 306.73, 305.42)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(308.16 305.54) rotate(5.62)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(309.57 305.68) rotate(6.32)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(310.98 305.83) rotate(7.02)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(312.2 305.98) rotate(7.63)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(313.43 306.15) rotate(8.25)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.99, 0.16, -0.16, 0.99, 314.65, 306.32)"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.98, 0.18, -0.18, 0.98, 317.48, 306.77)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(320.26 307.31) rotate(11.7)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.98, 0.21, -0.21, 0.98, 320.53, 307.36)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(321.93 307.65) rotate(12.55)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.97, 0.23, -0.23, 0.97, 323.31, 307.96)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(324.7 308.29) rotate(13.97)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(326.09 308.63) rotate(14.69)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.96, 0.27, -0.27, 0.96, 327.47, 308.99)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(328.84 309.37) rotate(16.11)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(330.23 309.77) rotate(16.83)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(331.59 310.18) rotate(17.54)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(332.94 310.61) rotate(18.25)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(334.28 311.05) rotate(18.96)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(335.66 311.53) rotate(19.69)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.94, 0.35, -0.35, 0.94, 336.99, 312)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.93, 0.36, -0.36, 0.93, 338.33, 312.5)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.93, 0.37, -0.37, 0.93, 339.67, 313.02)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(340.97 313.54) rotate(22.53)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(342.48 314.16) rotate(23.34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(343.95 314.8) rotate(24.14)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(345.4 315.46) rotate(24.94)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.9, 0.44, -0.44, 0.9, 346.86, 316.12)"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.89, 0.46, -0.46, 0.89, 349.43, 317.38)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(351.96 318.71) rotate(28.59)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(354.08 319.88) rotate(29.79)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.86, 0.51, -0.51, 0.86, 355.33, 320.59)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.86, 0.52, -0.52, 0.86, 356.56, 321.32)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.85, 0.53, -0.53, 0.85, 357.77, 322.05)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.84, 0.54, -0.54, 0.84, 358.97, 322.8)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.84, 0.55, -0.55, 0.84, 360.18, 323.57)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(361.38 324.36) rotate(34.04)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.82, 0.57, -0.57, 0.82, 362.57, 325.16)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(363.74 325.98) rotate(35.46)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.81, 0.59, -0.59, 0.81, 364.91, 326.81)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.8, 0.6, -0.6, 0.8, 366.06, 327.65)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(367.21 328.51) rotate(37.59)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.78, 0.62, -0.62, 0.78, 368.32, 329.37)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(369.44 330.26) rotate(38.99)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(370.56 331.16) rotate(39.69)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.76, 0.65, -0.65, 0.76, 371.66, 332.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(372.74 332.99) rotate(41.1)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(373.82 333.93) rotate(41.81)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(374.88 334.88) rotate(42.51)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(375.94 335.85) rotate(43.22)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(376.98 336.83) rotate(43.92)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.71, 0.71, -0.71, 0.71, 378.01, 337.81)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(380.03 339.83) rotate(46.39)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.68, 0.74, -0.74, 0.68, 382, 341.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(382.19 342.11) rotate(47.58)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(383.15 343.16) rotate(48.29)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.66, 0.75, -0.75, 0.66, 384.1, 344.23)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(385.04 345.31) rotate(49.7)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(385.96 346.4) rotate(50.4)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.63, 0.78, -0.78, 0.63, 386.87, 347.5)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.62, 0.79, -0.79, 0.62, 387.77, 348.61)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(388.66 349.74) rotate(52.52)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.6, 0.8, -0.8, 0.6, 389.51, 350.85)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.59, 0.81, -0.81, 0.59, 390.37, 352)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(391.21 353.16) rotate(54.64)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.57, 0.82, -0.82, 0.57, 392.04, 354.33)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(392.84 355.49) rotate(56.04)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(393.64 356.67) rotate(56.75)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.54, 0.84, -0.84, 0.54, 394.43, 357.87)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.53, 0.85, -0.85, 0.53, 395.2, 359.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(395.95 360.28) rotate(58.88)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(396.69 361.51) rotate(59.59)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.5, 0.87, -0.87, 0.5, 397.41, 362.73)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(398.12 363.98) rotate(61.01)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(398.82 365.24) rotate(61.73)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(399.49 366.49) rotate(62.43)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(400.15 367.75) rotate(63.14)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.44, 0.9, -0.9, 0.44, 400.79, 369.02)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(402.03 371.58) rotate(65.63)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(403.21 374.2) rotate(66.7)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(403.78 375.51) rotate(67.41)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(404.33 376.83) rotate(68.13)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(404.86 378.15) rotate(68.84)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(405.38 379.49) rotate(69.56)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(405.87 380.81) rotate(70.27)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(406.35 382.17) rotate(70.98)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(406.82 383.52) rotate(71.7)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(407.27 384.87) rotate(72.41)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(407.7 386.22) rotate(73.12)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(408.11 387.58) rotate(73.83)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(408.51 388.97) rotate(74.56)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.25, 0.97, -0.97, 0.25, 408.89, 390.35)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(409.26 391.73) rotate(75.98)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.23, 0.97, -0.97, 0.23, 409.6, 393.12)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.22, 0.98, -0.98, 0.22, 409.93, 394.49)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(410.24 395.89) rotate(78.12)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(410.54 397.3) rotate(78.84)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.18, 0.98, -0.98, 0.18, 410.81, 398.69)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.17, 0.99, -0.99, 0.17, 411.07, 400.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(411.31 401.51) rotate(80.97)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(411.53 402.9) rotate(81.67)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.13, 0.99, -0.99, 0.13, 411.74, 404.34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(411.93 405.73) rotate(83.09)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(412.11 407.15) rotate(84.16)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(412.4 409.99) rotate(85.57)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.06, 1, -1, 0.06, 412.61, 412.84)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(412.7 414.27) rotate(87.32)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(0.03, 1, -1, 0.03, 412.77, 415.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(412.81 417.12) rotate(88.72)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(412.84 418.56) rotate(89.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(412.87 419.96) rotate(90.93)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1.44,
    y: -0.01
  })), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.03, 1, -1, -0.03, 412.84, 422.82)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(412.8 424.26) rotate(92.2)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(412.75 425.69) rotate(92.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(412.67 427.12) rotate(93.6)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(412.59 428.54) rotate(94.31)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(412.48 429.96) rotate(95.01)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(412.35 431.37) rotate(95.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(412.21 432.8) rotate(96.42)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(412.05 434.23) rotate(97.13)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(411.88 435.63) rotate(97.83)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(411.68 437.07) rotate(98.55)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(411.47 438.46) rotate(99.25)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(411.24 439.88) rotate(99.97)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(410.99 441.28) rotate(100.68)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.2, 0.98, -0.98, -0.2, 410.73, 442.67)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(410.45 444.08) rotate(102.1)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(410.14 445.49) rotate(102.82)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(409.83 446.88) rotate(103.54)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(409.5 448.27) rotate(104.61)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(408.78 451.02) rotate(106.03)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(407.99 453.76) rotate(107.1)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(407.57 455.12) rotate(107.81)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(407.13 456.49) rotate(108.53)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(406.67 457.85) rotate(109.25)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.34, 0.94, -0.94, -0.34, 406.21, 459.19)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(405.72 460.54) rotate(110.67)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.36, 0.93, -0.93, -0.36, 405.21, 461.87)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(404.7 463.19) rotate(112.09)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(404.16 464.53) rotate(112.82)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(403.61 465.83) rotate(113.52)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.41, 0.91, -0.91, -0.41, 403.03, 467.15)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(402.45 468.45) rotate(114.95)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(401.85 469.74) rotate(115.66)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(401.23 471.02) rotate(116.37)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(400.6 472.3) rotate(117.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(399.95 473.58) rotate(117.8)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(399.27 474.85) rotate(118.51)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(398.6 476.1) rotate(119.22)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(397.91 477.33) rotate(119.92)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.51, 0.86, -0.86, -0.51, 397.19, 478.58)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.52, 0.85, -0.85, -0.52, 396.46, 479.82)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.53, 0.85, -0.85, -0.53, 395.72, 481.02)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(394.96 482.24) rotate(122.76)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.55, 0.83, -0.83, -0.55, 394.2, 483.43)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.56, 0.83, -0.83, -0.56, 393.41, 484.62)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.57, 0.82, -0.82, -0.57, 392.6, 485.81)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(391.78 486.98) rotate(125.59)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(390.96 488.15) rotate(126.65)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(389.24 490.44) rotate(127.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.62, 0.78, -0.78, -0.62, 388.37, 491.57)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(387.48 492.69) rotate(129.13)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(386.58 493.8) rotate(129.83)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(385.68 494.88) rotate(130.53)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(384.75 495.97) rotate(131.23)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.67, 0.74, -0.74, -0.67, 383.81, 497.04)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(382.85 498.1) rotate(132.64)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(381.89 499.15) rotate(133.34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.7, 0.72, -0.72, -0.7, 380.91, 500.19)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(379.92 501.22) rotate(134.75)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.71, 0.7, -0.7, -0.71, 378.91, 502.23)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.72, 0.69, -0.69, -0.72, 377.89, 503.23)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(376.83 504.25) rotate(136.89)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(375.74 505.27) rotate(137.63)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(374.65 506.26) rotate(138.35)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(373.55 507.24) rotate(139.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(372.44 508.21) rotate(139.81)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(371.32 509.16) rotate(140.53)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.78, 0.63, -0.63, -0.78, 370.18, 510.09)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.79, 0.62, -0.62, -0.79, 369.03, 511.01)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(367.87 511.92) rotate(142.72)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.8, 0.6, -0.6, -0.8, 366.7, 512.81)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(365.51 513.69) rotate(144.17)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.82, 0.57, -0.57, -0.82, 364.31, 514.56)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(363.11 515.4) rotate(145.63)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(361.89 516.24) rotate(146.37)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "matrix(-0.84, 0.54, -0.54, -0.84, 360.67, 517.06)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.65, 0.76, -0.76, 0.65, 130.82, 542.76)"
  }, "\xB0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.67, 0.74, -0.74, 0.67, 133.16, 545.48)"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(136.27 548.92) rotate(46.96)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(138.42 551.22) rotate(46.12)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(141.39 554.31) rotate(45.21)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(144.44 557.37) rotate(44.54)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(156.04 568.25) rotate(41.32)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.76, 0.65, -0.65, 0.76, 157.67, 569.68)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.76, 0.65, -0.65, 0.76, 159.28, 571.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(160.93 572.49) rotate(39.99)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.77, 0.64, -0.64, 0.77, 162.56, 573.86)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.78, 0.62, -0.62, 0.78, 164.99, 575.85)"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.79, 0.61, -0.61, 0.79, 168.36, 578.55)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.8, 0.6, -0.6, 0.8, 171.76, 581.17)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.84, 0.55, -0.55, 0.84, 184.42, 590.17)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.84, 0.54, -0.54, 0.84, 186.21, 591.33)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.85, 0.53, -0.53, 0.85, 188.03, 592.5)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(189.84 593.64) rotate(31.53)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(191.67 594.76) rotate(30.8)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(194.36 596.38) rotate(29.75)"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(198.09 598.51) rotate(28.49)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(201.85 600.54) rotate(27.52)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(215.96 607.22) rotate(22.39)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(217.95 608.04) rotate(21.98)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(219.93 608.84) rotate(21.49)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(221.93 609.63) rotate(20.87)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(224.86 610.76) rotate(19.99)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(228.88 612.22) rotate(18.97)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(232.96 613.61) rotate(18.18)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(249.93 618.55) rotate(13.69)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.97, 0.23, -0.23, 0.97, 252.03, 619.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(254.11 619.55) rotate(12.55)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(256.21 620.02) rotate(11.83)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(259.28 620.67) rotate(10.82)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(263.48 621.47) rotate(9.64)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(267.73 622.19) rotate(8.74)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(285.27 624.19) rotate(3.64)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(287.6 624.34) rotate(2.95)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(289.96 624.46) rotate(2.26)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(292.29 624.55) rotate(1.57)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(1, 0.02, -0.02, 1, 294.62, 624.61)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(296.96 624.66) rotate(-0.09)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(301.25 624.64) rotate(-0.96)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(321.68 623.47) rotate(-9.45)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(323.88 623.11) rotate(-10.46)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(326.05 622.71) rotate(-11.28)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(328.17 622.28) rotate(-11.97)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(330.25 621.85) rotate(-12.85)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(334.44 620.89) rotate(-13.85)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(338.61 619.86) rotate(-14.51)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(356.64 614.7) rotate(-17.7)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(358.67 614.05) rotate(-18.04)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(360.7 613.39) rotate(-18.38)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(362.77 612.7) rotate(-18.73)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(364.8 612.02) rotate(-19.26)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(368.85 610.6) rotate(-19.98)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.94, -0.35, 0.35, 0.94, 372.89, 609.13)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(390.46 601.88) rotate(-26.62)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.88, -0.47, 0.47, 0.88, 392.47, 600.87)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.88, -0.48, 0.48, 0.88, 394.44, 599.83)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(396.43 598.74) rotate(-30.39)"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.85, -0.53, 0.53, 0.85, 400.28, 596.48)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(404 594.12) rotate(-33.45)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(420.75 581.8) rotate(-39.35)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(422.25 580.58) rotate(-39.77)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(423.74 579.34) rotate(-40.18)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(425.24 578.08) rotate(-40.79)"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(428.49 575.27) rotate(-41.59)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.74, -0.67, 0.67, 0.74, 431.7, 572.42)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(447.3 557.59) rotate(-45.02)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.7, -0.71, 0.71, 0.7, 448.82, 556.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(450.34 554.53) rotate(-45.45)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.7, -0.72, 0.72, 0.7, 451.86, 553)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.69, -0.72, 0.72, 0.69, 454.86, 549.92)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.69, -0.72, 0.72, 0.69, 457.84, 546.82)"
  }, "\xB0"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(460.33 544.21) rotate(-46.59)"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "matrix(0.65, 0.76, -0.76, 0.65, 123.83, 549.63)"
  }, "\xB0F"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_67",
    transform: "translate(468.79 554.81) rotate(-50.83)"
  }, "\xB0F"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(268.02 242.15) rotate(-8.29)"
  }, "K"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(1, -0.09, 0.09, 1, 275.59, 241.01)"
  }, "M"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(1, -0.05, 0.05, 1, 285.69, 240.11)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(290.01 239.84) rotate(-0.94)"
  }, "M"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(300.13 239.75) rotate(1.64)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(304.46 239.85) rotate(3.37)"
  }, "L"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(309.72 240.14) rotate(5.12)"
  }, "T"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.99, 0.13, -0.13, 0.99, 316.25, 240.7)"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.99, 0.16, -0.16, 0.99, 324.08, 241.76)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(339.5 244.8) rotate(15.18)"
  }, "Y"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.96, 0.29, -0.29, 0.96, 345.63, 246.46)"
  }, "a"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(351.5 248.27) rotate(18.68)"
  }, "r"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(354.8 249.35) rotate(20.34)"
  }, "d"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(361.16 251.71) rotate(22.39)"
  }, "s"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.91, 0.4, -0.4, 0.91, 366.41, 253.89)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.9, 0.44, -0.44, 0.9, 373.33, 257.05)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.79, 0.62, -0.62, 0.79, 403.93, 275.89)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.65, 0.76, -0.76, 0.65, 430.12, 300.56)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(432.09 302.87) rotate(50.57)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(434.02 305.21) rotate(51.54)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(435.91 307.58) rotate(52.51)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(437.75 309.99) rotate(53.49)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.58, 0.81, -0.81, 0.58, 439.56, 312.43)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.57, 0.82, -0.82, 0.57, 441.33, 314.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.55, 0.83, -0.83, 0.55, 443.06, 317.4)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(444.76 319.9) rotate(58.09)"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.49, 0.87, -0.87, 0.49, 448.7, 326.21)"
  }, "p"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.47, 0.88, -0.88, 0.47, 452.04, 332.14)"
  }, "."), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(453.48 334.84) rotate(62.93)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(454.9 337.49) rotate(64.82)"
  }, "G"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(458.6 345.46) rotate(66.72)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(465.23 362.9) rotate(72.72)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(472.74 398.07) rotate(84.24)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.1, 1, -1, -0.1, 473.13, 434.04)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(466.41 469.36) rotate(107.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(465.52 472.27) rotate(108.05)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.33, 0.95, -0.95, -0.33, 464.58, 475.16)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(463.6 478.03) rotate(110)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.36, 0.93, -0.93, -0.36, 462.56, 480.87)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.37, 0.93, -0.93, -0.37, 461.47, 483.72)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.39, 0.92, -0.92, -0.39, 460.35, 486.52)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.41, 0.91, -0.91, -0.41, 459.16, 489.33)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(457.93 492.11) rotate(114.88)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(456.66 494.86) rotate(115.86)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(455.33 497.61) rotate(116.8)"
  }, "I"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(454.14 500.12) rotate(118.84)"
  }, "m"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(449.34 508.76) rotate(121.51)"
  }, "p"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(445.76 514.57) rotate(123.09)"
  }, "."), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(444.11 517.12) rotate(124.06)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(442.46 519.64) rotate(125.96)"
  }, "G"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(437.29 526.73) rotate(128.34)"
  }, "a"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.64, 0.77, -0.77, -0.64, 433.48, 531.53)"
  }, "l"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.65, 0.76, -0.76, -0.65, 431.95, 533.37)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.66, 0.75, -0.75, -0.66, 429.98, 535.67)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.68, 0.74, -0.74, -0.68, 427.98, 537.94)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(425.92 540.19) rotate(133.49)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.7, 0.71, -0.71, -0.7, 423.83, 542.4)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(421.72 544.56) rotate(135.44)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.72, 0.69, -0.69, -0.72, 419.54, 546.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(417.35 548.79) rotate(137.39)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.76, 0.65, -0.65, -0.76, 415.17, 550.87)"
  }, "U"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.79, 0.62, -0.62, -0.79, 408.86, 556.3)"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(402.97 560.91) rotate(143.46)"
  }, "."), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.81, 0.58, -0.58, -0.81, 400.54, 562.72)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(398.13 564.5) rotate(146.35)"
  }, "G"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(390.79 569.37) rotate(148.77)"
  }, "a"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(385.53 572.53) rotate(150.15)"
  }, "l"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.87, 0.48, -0.48, -0.87, 383.48, 573.71)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(380.82 575.19) rotate(152.03)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.89, 0.45, -0.45, -0.89, 378.16, 576.61)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.9, 0.44, -0.44, -0.9, 375.45, 577.99)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.91, 0.4, -0.4, -0.91, 372.78, 579.37)"
  }, "M"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(363.48 583.42) rotate(158.44)"
  }, "/"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(360.08 584.8) rotate(160.27)"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(353.07 587.31) rotate(162.51)"
  }, "e"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.96, 0.27, -0.27, -0.96, 347.24, 589.15)"
  }, "c"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(341.32 590.77) rotate(166.03)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(307.93 596.03) rotate(177.14)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(304.89 596.18) rotate(178.12)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(301.84 596.29) rotate(179.06)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(298.82 596.36) rotate(-179.06)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(295.79 596.33) rotate(-178.95)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(292.74 596.28) rotate(-177.96)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(289.7 596.18) rotate(-176.98)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(286.68 596.02) rotate(-175.99)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-1, -0.09, 0.09, -1, 283.63, 595.81)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(280.63 595.58) rotate(-173.43)"
  }, "F"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(274.1 594.83) rotate(-171.35)"
  }, "e"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(268.05 593.91) rotate(-169.34)"
  }, "e"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(262.04 592.77) rotate(-167.76)"
  }, "t"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.97, -0.23, 0.23, -0.97, 258.64, 592.03)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(237.16 585.68) rotate(-159.29)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.84, -0.54, 0.54, -0.84, 204.86, 569.88)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(176.46 547.87) rotate(-135.88)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.56, -0.83, 0.83, -0.56, 153.03, 520.58)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(135.54 489.15) rotate(-112.77)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(134.37 486.36) rotate(-111.8)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(-0.34, -0.94, 0.94, -0.34, 133.21, 483.59)"
  }, "N"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(130.37 475.74) rotate(-107.65)"
  }, "a"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(128.51 469.91) rotate(-105.64)"
  }, "u"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(126.81 463.77) rotate(-104.06)"
  }, "t"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(125.96 460.41) rotate(-103.02)"
  }, "."), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(125.27 457.44) rotate(-102.05)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(124.58 454.53) rotate(-99.95)"
  }, "M"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(122.89 444.53) rotate(-97.85)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(120.93 419.13) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(120.96 416.06) rotate(-88.86)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(120.99 413.05) rotate(-87.22)"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(121.37 405.57) rotate(-85.49)"
  }, "t"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(121.62 402.13) rotate(-83.98)"
  }, "a"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(122.28 396.03) rotate(-82.45)"
  }, "t"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(122.74 392.58) rotate(-81.41)"
  }, "."), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(123.19 389.57) rotate(-80.44)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(123.62 386.6) rotate(-78.34)"
  }, "M"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(125.72 376.68) rotate(-76.24)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.25, -0.97, 0.97, 0.25, 126.44, 373.73)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(127.21 370.81) rotate(-74.29)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(128.03 367.87) rotate(-73.31)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.3, -0.95, 0.95, 0.3, 128.91, 364.95)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.32, -0.95, 0.95, 0.32, 129.83, 362.05)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.34, -0.94, 0.94, 0.34, 130.79, 359.18)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(131.81 356.32) rotate(-69.41)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(132.83 353.5) rotate(-67.73)"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.42, -0.91, 0.91, 0.42, 135.66, 346.59)"
  }, "p"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(138.5 340.42) rotate(-63.86)"
  }, "."), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(139.85 337.67) rotate(-62.87)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.49, -0.87, 0.87, 0.49, 141.16, 334.98)"
  }, "G"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(145.47 327.31) rotate(-59.09)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(151.83 317.24) rotate(-55.27)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(174.91 289.69) rotate(-43.73)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(177.12 287.58) rotate(-42.75)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(179.34 285.52) rotate(-41.78)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(181.62 283.48) rotate(-40.79)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.78, -0.63, 0.63, 0.78, 183.87, 281.49)"
  }, "K"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "translate(189.8 276.64) rotate(-36.41)"
  }, "G"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_74",
    transform: "matrix(0.83, -0.56, 0.56, 0.83, 196.86, 271.45)"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(236.44 576.96) rotate(-157.54)",
    letterSpacing: "-.12em",
    fontFamily: "HelveticaNeue-Roman, Helvetica Neue",
    fontSize: 12.05,
    fill: "#a32136"
  }, "T", /*#__PURE__*/React.createElement("tspan", {
    className: "crp5_76",
    x: 5.53,
    y: 0
  }, "AS")), /*#__PURE__*/React.createElement("text", {
    className: "crp5_77",
    transform: "matrix(0.97, 0.25, -0.25, 0.97, 315.02, 323.56)"
  }, "Mach No", /*#__PURE__*/React.createElement("tspan", {
    letterSpacing: "-.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 3.92,
    y: 6
  }, "Index"))), /*#__PURE__*/React.createElement("text", {
    className: "crp5_78",
    transform: "matrix(0.96, -0.28, 0.28, 0.96, 240.74, 225.95)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_78",
    transform: "translate(245.71 224.48) rotate(-13.57)"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_78",
    transform: "translate(259.07 221.39) rotate(-9.67)"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_78",
    transform: "translate(272.1 219.3) rotate(-5.93)"
  }, "P"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_78",
    transform: "translate(284.76 218.14) rotate(-2.81)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_78",
    transform: "matrix(1, 0.02, -0.02, 1, 293.85, 217.7)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_78",
    transform: "translate(305.28 217.91) rotate(2.8)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "crp5_78",
    transform: "translate(314.03 218.38) rotate(6.2)"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_78",
    transform: "translate(327.01 219.88) rotate(10.04)"
  }, "O"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_78",
    transform: "translate(340.38 222.33) rotate(14.21)"
  }, "M"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_78",
    transform: "translate(355.03 226.2) rotate(18.16)"
  }, "P"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_78",
    transform: "translate(366.46 230.04) rotate(21.82)"
  }, "U"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_78",
    transform: "matrix(0.9, 0.43, -0.43, 0.9, 378.55, 235.01)"
  }, "T"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_78",
    transform: "translate(388.48 239.79) rotate(28.58)"
  }, "E"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_78",
    transform: "translate(398.57 245.37) rotate(32.06)"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    className: "crp5_69",
    transform: "translate(179.92 437.02)"
  }, "8"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrp5FrontFrame);
export default __webpack_public_path__ + "static/media/crp5-front-frame.a4ed43df054a00dcbfecae245f68f4b6.svg";
export { ForwardRef as ReactComponent };